
export const typeClients = [
    {nom: "Choisir Type", id: 0,},
    {nom: "Client Business", id: 5,},
    {nom: "Client Business Admin", id: 6,},
    {nom: "Client", id: 10,},
]
export const typeAgents = [
    {nom: "Choisir Type", id: 0,},
    {nom: "Agent", id: 4,},
    {nom: "Agent Modifier", id: 12,},
    {nom: "Agent Admin", id: 3,},
    {nom: "Caissier", id: 11,},
]
export const typeLivs = [
    {nom: "Choisir Type", id: 0,},
    {nom: "Livreur", id: 7,},
    {nom: "Transporteur", id: 8,},
]
export const typeEnvois = [
    { nom: "Avec accusé", id: 1},
    { nom: "Sans accusé", id: 2},
    { nom: "Pick up", id: 3},
]
export const currentStatusEnvois = [
    { nom: "NWE", id: 1},
    { nom: "ACC", id: 2},
    { nom: "RTR", id: 3},
    { nom: "ANL", id: 4},
]
export const NatureEnvois = [
    { nom: "Document", id: 1},
    { nom: "Marchandise", id: 2},
]
export const typeDeliveries = [
    { nom: "Livraison A Domicile", id: 1},
    { nom: "Livraison Stop Desk", id: 2},
]
export const typeRamassages = [
    { nom: "Dépot A Domicile", id: 1},
    { nom: "Dépot En Agence", id: 2},
]
export const clientsOrEntreprises = [
    { nom: "Entreprise", id: 1},
    { nom: "Client", id: 2},
]
export const withTVAs = [
    { nom: "Avec TVA", id: 1},
    { nom: "Sans TVA", id: 2},
]
export const validStates = [
    { nom: "Non Valider", id: 0},
    { nom: "Valider", id: 1},
]
export const pricesClientsAndEntreprises = [
    { nom: "Prix Entreprise", id: 1},
    { nom: "Prix Client", id: 2},
]
export const actionsPaiement = [
    { nom: "Tous", id: 1},
    { nom: "Avec Paiement", id: 2},
]
export const listItems = [5, 10, 20, 30, 40, 50, 100];

export const statusEnvois = [
    { nom: "Preparation", id: 10 },
    { nom: "Ramassage", id: 1 },
    { nom: "Réception Agence", id: 8 },
    { nom: "Dépot Client", id: 2 },
    // { nom: "Acheminement Départ", id: 3 },
    { nom: "Dispatch", id: 3 },
    // { nom: "Acheminement Arrivé", id: 4 },
    { nom: "Centre", id: 4 },
    // { nom: "Livraison Domicile", id: 5 },
    { nom: "Affectation Livreur", id: 5 },
    // { nom: "Livraison Agence", id: 6 },
    { nom: "Livré Stop Desk", id: 6 },
    { nom: "Retour Client", id: 11 },
    { nom: "Stock Agence", id: 9 },
    { nom: "Undo", id: 7 },
]

export const typeActionsEnvois = [
    { nom: "Ramassage", id: 1 },
    { nom: "Réception Agence", id: 8 },
    { nom: "Dépot Client", id: 2 },
    // { nom: "Acheminement Départ", id: 3 },
    { nom: "Dispatch", id: 3 },
    // { nom: "Acheminement Arrivé", id: 4 },
    { nom: "Centre", id: 4 },
    // { nom: "Livraison Domicile", id: 5 },
    { nom: "Affectation Livreur", id: 5 },
    // { nom: "Livraison Agence", id: 6 },
    { nom: "Livré Stop Desk", id: 6 },
    { nom: "Retour Client", id: 11 },
    { nom: "Stock Agence", id: 9 },
]

export const typeMovements = [
    { nom: "Encaissement", id: 1 },
    { nom: "Facture", id: 4 },
    { nom: "Décharge Client", id: 2 },
    { nom: "Décharge Retour/Autre", id: 3 },
]

export const historyCases = [
    { nom: "Ramassage avec succès", id: 4 },
    { nom: "Ramassage avec Echec", id: 5 },
    { nom: "Livraison avec succès", id: 1 },
    { nom: "Livraison avec Echec", id: 3 },
    { nom: "Reporter", id: 6 },
    { nom: "Unjoinable", id: 2 },
]

export const actionTypes = [
    { nom: "Action Tracking", id: 1 },
    { nom: "Action Etat", id: 2 },
]

export const wilayas = [
    {nom: "Choisir Wilaya",id: 0,},
    {nom: "Adrar",id: 1,},
    {nom: "Chlef",id: 2,},
    {nom: "Laghouat",id: 3,},
    {nom: "Oum El Bouaghi",id: 4,},
    {nom: "Batna",id: 5,},
    {nom: "Béjaïa",id: 6,},
    {nom: "Biskra",id: 7,},
    {nom: "Béchar",id: 8,},
    {nom: "Blida",id: 9,},
    {nom: "Bouira",id: 10,},
    {nom: "Tamanrasset",id: 11,},
    {nom: "Tébessa",id: 12,},
    {nom: "Tlemcen",id: 13,},
    {nom: "Tiaret",id: 14,},
    {nom: "Tizi Ouzou",id: 15,},
    {nom: "Alger",id: 16,},
    {nom: "Djelfa",id: 17,},
    {nom: "Jijel",id: 18,},
    {nom: "Sétif",id: 19,},
    {nom: "Saïda",id: 20,},
    {nom: "Skikda",id: 21,},
    {nom: "Sidi Bel Abbès",id: 22,},
    {nom: "Annaba",id: 23,},
    {nom: "Guelma",id: 24,},
    {nom: "Constantine",id: 25,},
    {nom: "Médéa",id: 26,},
    {nom: "Mostaganem",id: 27,},
    {nom: "M'Sila",id: 28,},
    {nom: "Mascara",id: 29,},
    {nom: "Ouargla",id: 30,},
    {nom: "Oran",id: 31,},
    {nom: "El Bayadh",id: 32,},
    {nom: "Illizi",id: 33,},
    {nom: "Bordj Bou Arreridj",id: 34,},
    {nom: "Boumerdès",id: 35,},
    {nom: "El Tarf",id: 36,},
    {nom: "Tindouf",id: 37,},
    {nom: "Tissemsilt",id: 38,},
    {nom: "El Oued",id: 39,},
    {nom: "Khenchela",id: 40,},
    {nom: "Souk Ahras",id: 41,},
    {nom: "Tipaza",id: 42,},
    {nom: "Mila",id: 43,},
    {nom: "Aïn Defla",id: 44,},
    {nom: "Naâma",id: 45,},
    {nom: "Aïn Témouchent",id: 46,},
    {nom: "Ghardaïa",id: 47,},
    {nom: "Relizane",id: 48,},
    {nom: "Timimoun",id: 49,},
    {nom: "Bordj Badji Mokhtar",id: 50,},
    {nom: "Ouled Djellal",id: 51,},
    {nom: "Béni Abbès",id: 52,},
    {nom: "In Salah",id: 53,},
    {nom: "In Guezzam",id: 54,},
    {nom: "Touggourt",id: 55,},   
    {nom: "Djanet",id: 56,},
    {nom: "El M'Ghair",id: 57,},
    {nom: "El Menia",id: 58,},
]

// list of wilaya without id=0
export const wilayas2 = [
    {nom: "Adrar",id: 1,},
    {nom: "Chlef",id: 2,},
    {nom: "Laghouat",id: 3,},
    {nom: "Oum El Bouaghi",id: 4,},
    {nom: "Batna",id: 5,},
    {nom: "Béjaïa",id: 6,},
    {nom: "Biskra",id: 7,},
    {nom: "Béchar",id: 8,},
    {nom: "Blida",id: 9,},
    {nom: "Bouira",id: 10,},
    {nom: "Tamanrasset",id: 11,},
    {nom: "Tébessa",id: 12,},
    {nom: "Tlemcen",id: 13,},
    {nom: "Tiaret",id: 14,},
    {nom: "Tizi Ouzou",id: 15,},
    {nom: "Alger",id: 16,},
    {nom: "Djelfa",id: 17,},
    {nom: "Jijel",id: 18,},
    {nom: "Sétif",id: 19,},
    {nom: "Saïda",id: 20,},
    {nom: "Skikda",id: 21,},
    {nom: "Sidi Bel Abbès",id: 22,},
    {nom: "Annaba",id: 23,},
    {nom: "Guelma",id: 24,},
    {nom: "Constantine",id: 25,},
    {nom: "Médéa",id: 26,},
    {nom: "Mostaganem",id: 27,},
    {nom: "M'Sila",id: 28,},
    {nom: "Mascara",id: 29,},
    {nom: "Ouargla",id: 30,},
    {nom: "Oran",id: 31,},
    {nom: "El Bayadh",id: 32,},
    {nom: "Illizi",id: 33,},
    {nom: "Bordj Bou Arreridj",id: 34,},
    {nom: "Boumerdès",id: 35,},
    {nom: "El Tarf",id: 36,},
    {nom: "Tindouf",id: 37,},
    {nom: "Tissemsilt",id: 38,},
    {nom: "El Oued",id: 39,},
    {nom: "Khenchela",id: 40,},
    {nom: "Souk Ahras",id: 41,},
    {nom: "Tipaza",id: 42,},
    {nom: "Mila",id: 43,},
    {nom: "Aïn Defla",id: 44,},
    {nom: "Naâma",id: 45,},
    {nom: "Aïn Témouchent",id: 46,},
    {nom: "Ghardaïa",id: 47,},
    {nom: "Relizane",id: 48,},
    {nom: "Timimoun",id: 49,},
    {nom: "Bordj Badji Mokhtar",id: 50,},
    {nom: "Ouled Djellal",id: 51,},
    {nom: "Béni Abbès",id: 52,},
    {nom: "In Salah",id: 53,},
    {nom: "In Guezzam",id: 54,},
    {nom: "Touggourt",id: 55,},   
    {nom: "Djanet",id: 56,},
    {nom: "El M'Ghair",id: 57,},
    {nom: "El Menia",id: 58,},
]

export const communes = [
    [{id:0, nom: "Choisir Commune",},],
    [{id:0, nom: "Choisir Commune",},
        {id:1, code_postal:'01001', nom:'Adrar', code_wilaya:1},
        {id:2, code_postal:'01002', nom:'Tamest', code_wilaya:1},
        {id:3, code_postal:'01003', nom:'Charouine', code_wilaya:1},
        {id:4, code_postal:'01004', nom:'Reggane', code_wilaya:1},
        {id:5, code_postal:'01005', nom:'Inozghmir', code_wilaya:1},
        {id:6, code_postal:'01006', nom:'Tit', code_wilaya:1},
        {id:7, code_postal:'01007', nom:'Ksar Kaddour', code_wilaya:1},
        {id:8, code_postal:'01008', nom:'Tsabit', code_wilaya:1},
        {id:9, code_postal:'01009', nom:'Timimoun', code_wilaya:1},
        {id:10, code_postal:'01010', nom:'Ouled Said', code_wilaya:1},
        {id:11, code_postal:'01011', nom:'Zaouiet Kounta', code_wilaya:1},
        {id:12, code_postal:'01012', nom:'Aoulef', code_wilaya:1},
        {id:13, code_postal:'01013', nom:'Timokten', code_wilaya:1},
        {id:14, code_postal:'01014', nom:'Tamentit', code_wilaya:1},
        {id:15, code_postal:'01015', nom:'Fenoughil', code_wilaya:1},
        {id:16, code_postal:'01016', nom:'Tinerkouk', code_wilaya:1},
        {id:17, code_postal:'01017', nom:'Deldoul', code_wilaya:1},
        {id:18, code_postal:'01018', nom:'Sali', code_wilaya:1},
        {id:19, code_postal:'01019', nom:'Akabli', code_wilaya:1},
        {id:20, code_postal:'01020', nom:'Metarfa', code_wilaya:1},
        {id:21, code_postal:'01021', nom:'O Ahmed Timmi', code_wilaya:1},
        {id:22, code_postal:'01022', nom:'Bouda', code_wilaya:1},
        {id:23, code_postal:'01023', nom:'Aougrout', code_wilaya:1},
        {id:24, code_postal:'01024', nom:'Talmine', code_wilaya:1},
        {id:25, code_postal:'01025', nom:'B Badji Mokhtar', code_wilaya:1},
        {id:26, code_postal:'01026', nom:'Sbaa', code_wilaya:1},
        {id:27, code_postal:'01027', nom:'Ouled Aissa', code_wilaya:1},
        {id:28, code_postal:'01028', nom:'Timiaouine', code_wilaya:1},],
    [{id:0, nom: "Choisir Commune",},
        {id:29, code_postal:'02001', nom:'Chlef', code_wilaya:2},
        {id:30, code_postal:'02002', nom:'Tenes', code_wilaya:2},
        {id:31, code_postal:'02003', nom:'Benairia', code_wilaya:2},
        {id:32, code_postal:'02004', nom:'El Karimia', code_wilaya:2},
        {id:33, code_postal:'02005', nom:'Tadjna', code_wilaya:2},
        {id:34, code_postal:'02006', nom:'Taougrite', code_wilaya:2},
        {id:35, code_postal:'02007', nom:'Beni Haoua', code_wilaya:2},
        {id:36, code_postal:'02008', nom:'Sobha', code_wilaya:2},
        {id:37, code_postal:'02009', nom:'Harchoun', code_wilaya:2},
        {id:38, code_postal:'02010', nom:'Ouled Fares', code_wilaya:2},
        {id:39, code_postal:'02011', nom:'Sidi Akacha', code_wilaya:2},
        {id:40, code_postal:'02012', nom:'Boukadir', code_wilaya:2},
        {id:41, code_postal:'02013', nom:'Beni Rached', code_wilaya:2},
        {id:42, code_postal:'02014', nom:'Talassa', code_wilaya:2},
        {id:43, code_postal:'02015', nom:'Herenfa', code_wilaya:2},
        {id:44, code_postal:'02016', nom:'Oued Goussine', code_wilaya:2},
        {id:45, code_postal:'02017', nom:'Dahra', code_wilaya:2},
        {id:46, code_postal:'02018', nom:'Ouled Abbes', code_wilaya:2},
        {id:47, code_postal:'02019', nom:'Sendjas', code_wilaya:2},
        {id:48, code_postal:'02020', nom:'Zeboudja', code_wilaya:2},
        {id:49, code_postal:'02021', nom:'Oued Sly', code_wilaya:2},
        {id:50, code_postal:'02022', nom:'Abou El Hassen', code_wilaya:2},
        {id:51, code_postal:'02023', nom:'El Marsa', code_wilaya:2},
        {id:52, code_postal:'02024', nom:'Chettia', code_wilaya:2},
        {id:53, code_postal:'02025', nom:'Sidi Abderrahmane', code_wilaya:2},
        {id:54, code_postal:'02026', nom:'Moussadek', code_wilaya:2},
        {id:55, code_postal:'02027', nom:'El Hadjadj', code_wilaya:2},
        {id:56, code_postal:'02028', nom:'Labiod Medjadja', code_wilaya:2},
        {id:57, code_postal:'02029', nom:'Oued Fodda', code_wilaya:2},
        {id:58, code_postal:'02030', nom:'Ouled Ben Abdelkader', code_wilaya:2},
        {id:59, code_postal:'02031', nom:'Bouzghaia', code_wilaya:2},
        {id:60, code_postal:'02032', nom:'Ain Merane', code_wilaya:2},
        {id:61, code_postal:'02033', nom:'Oum Drou', code_wilaya:2},
        {id:62, code_postal:'02034', nom:'Breira', code_wilaya:2},
        {id:63, code_postal:'02035', nom:'Ben Boutaleb', code_wilaya:2},],
    [{id:0, nom: "Choisir Commune",},
        {id:64, code_postal:'03001', nom:'Laghouat', code_wilaya:3},
        {id:65, code_postal:'03002', nom:'Ksar El Hirane', code_wilaya:3},
        {id:66, code_postal:'03003', nom:'Benacer Ben Chohra', code_wilaya:3},
        {id:67, code_postal:'03004', nom:'Sidi Makhlouf', code_wilaya:3},
        {id:68, code_postal:'03005', nom:'Hassi Delaa', code_wilaya:3},
        {id:69, code_postal:'03006', nom:'Hassi R Mel', code_wilaya:3},
        {id:70, code_postal:'03007', nom:'Ain Mahdi', code_wilaya:3},
        {id:71, code_postal:'03008', nom:'Tadjmout', code_wilaya:3},
        {id:72, code_postal:'03009', nom:'Kheneg', code_wilaya:3},
        {id:73, code_postal:'03010', nom:'Gueltat Sidi Saad', code_wilaya:3},
        {id:74, code_postal:'03011', nom:'Ain Sidi Ali', code_wilaya:3},
        {id:75, code_postal:'03012', nom:'Beidha', code_wilaya:3},
        {id:76, code_postal:'03013', nom:'Brida', code_wilaya:3},
        {id:77, code_postal:'03014', nom:'El Ghicha', code_wilaya:3},
        {id:78, code_postal:'03015', nom:'Hadj Mechri', code_wilaya:3},
        {id:79, code_postal:'03016', nom:'Sebgag', code_wilaya:3},
        {id:80, code_postal:'03017', nom:'Taouiala', code_wilaya:3},
        {id:81, code_postal:'03018', nom:'Tadjrouna', code_wilaya:3},
        {id:82, code_postal:'03019', nom:'Aflou', code_wilaya:3},
        {id:83, code_postal:'03020', nom:'El Assafia', code_wilaya:3},
        {id:84, code_postal:'03021', nom:'Oued Morra', code_wilaya:3},
        {id:85, code_postal:'03022', nom:'Oued M Zi', code_wilaya:3},
        {id:86, code_postal:'03023', nom:'El Haouaita', code_wilaya:3},
        {id:87, code_postal:'03024', nom:'Sidi Bouzid', code_wilaya:3},],
    [{id:0, nom: "Choisir Commune",},
        {id:88, code_postal:'04001', nom:'Oum El Bouaghi', code_wilaya:4},
        {id:89, code_postal:'04002', nom:'Ain Beida', code_wilaya:4},
        {id:90, code_postal:'04003', nom:'Ainmlila', code_wilaya:4},
        {id:91, code_postal:'04004', nom:'Behir Chergui', code_wilaya:4},
        {id:92, code_postal:'04005', nom:'El Amiria', code_wilaya:4},
        {id:93, code_postal:'04006', nom:'Sigus', code_wilaya:4},
        {id:94, code_postal:'04007', nom:'El Belala', code_wilaya:4},
        {id:95, code_postal:'04008', nom:'Ain Babouche', code_wilaya:4},
        {id:96, code_postal:'04009', nom:'Berriche', code_wilaya:4},
        {id:97, code_postal:'04010', nom:'Ouled Hamla', code_wilaya:4},
        {id:98, code_postal:'04011', nom:'Dhala', code_wilaya:4},
        {id:99, code_postal:'04012', nom:'Ain Kercha', code_wilaya:4},
        {id:100, code_postal:'04013', nom:'Hanchir Toumghani', code_wilaya:4},
        {id:101, code_postal:'04014', nom:'El Djazia', code_wilaya:4},
        {id:102, code_postal:'04015', nom:'Ain Diss', code_wilaya:4},
        {id:103, code_postal:'04016', nom:'Fkirina', code_wilaya:4},
        {id:104, code_postal:'04017', nom:'Souk Naamane', code_wilaya:4},
        {id:105, code_postal:'04018', nom:'Zorg', code_wilaya:4},
        {id:106, code_postal:'04019', nom:'El Fedjoudj Boughrar', code_wilaya:4},
        {id:107, code_postal:'04020', nom:'Ouled Zouai', code_wilaya:4},
        {id:108, code_postal:'04021', nom:'Bir Chouhada', code_wilaya:4},
        {id:109, code_postal:'04022', nom:'Ksar Sbahi', code_wilaya:4},
        {id:110, code_postal:'04023', nom:'Oued Nini', code_wilaya:4},
        {id:111, code_postal:'04024', nom:'Meskiana', code_wilaya:4},
        {id:112, code_postal:'04025', nom:'Ain Fekroune', code_wilaya:4},
        {id:113, code_postal:'04026', nom:'Rahia', code_wilaya:4},
        {id:114, code_postal:'04027', nom:'Ain Zitoun', code_wilaya:4},
        {id:115, code_postal:'04028', nom:'Ouled Gacem', code_wilaya:4},
        {id:116, code_postal:'04029', nom:'El Harmilia', code_wilaya:4},],
    [{id:0, nom: "Choisir Commune",},
        {id:117, code_postal:'05001', nom:'Batna', code_wilaya:5},
        {id:118, code_postal:'05002', nom:'Ghassira', code_wilaya:5},
        {id:119, code_postal:'05003', nom:'Maafa', code_wilaya:5},
        {id:120, code_postal:'05004', nom:'Merouana', code_wilaya:5},
        {id:121, code_postal:'05005', nom:'Seriana', code_wilaya:5},
        {id:122, code_postal:'05006', nom:'Menaa', code_wilaya:5},
        {id:123, code_postal:'05007', nom:'El Madher', code_wilaya:5},
        {id:124, code_postal:'05008', nom:'Tazoult', code_wilaya:5},
        {id:125, code_postal:'05009', nom:'Ngaous', code_wilaya:5},
        {id:126, code_postal:'05010', nom:'Guigba', code_wilaya:5},
        {id:127, code_postal:'05011', nom:'Inoughissen', code_wilaya:5},
        {id:128, code_postal:'05012', nom:'Ouyoun El Assafir', code_wilaya:5},
        {id:129, code_postal:'05013', nom:'Djerma', code_wilaya:5},
        {id:130, code_postal:'05014', nom:'Bitam', code_wilaya:5},
        {id:131, code_postal:'05015', nom:'Metkaouak', code_wilaya:5},
        {id:132, code_postal:'05016', nom:'Arris', code_wilaya:5},
        {id:133, code_postal:'05017', nom:'Kimmel', code_wilaya:5},
        {id:134, code_postal:'05018', nom:'Tilatou', code_wilaya:5},
        {id:135, code_postal:'05019', nom:'Ain Djasser', code_wilaya:5},
        {id:136, code_postal:'05020', nom:'Ouled Selam', code_wilaya:5},
        {id:137, code_postal:'05021', nom:'Tigherghar', code_wilaya:5},
        {id:138, code_postal:'05022', nom:'Ain Yagout', code_wilaya:5},
        {id:139, code_postal:'05023', nom:'Fesdis', code_wilaya:5},
        {id:140, code_postal:'05024', nom:'Sefiane', code_wilaya:5},
        {id:141, code_postal:'05025', nom:'Rahbat', code_wilaya:5},
        {id:142, code_postal:'05026', nom:'Tighanimine', code_wilaya:5},
        {id:143, code_postal:'05027', nom:'Lemsane', code_wilaya:5},
        {id:144, code_postal:'05028', nom:'Ksar Belezma', code_wilaya:5},
        {id:145, code_postal:'05029', nom:'Seggana', code_wilaya:5},
        {id:146, code_postal:'05030', nom:'Ichmoul', code_wilaya:5},
        {id:147, code_postal:'05031', nom:'Foum Toub', code_wilaya:5},
        {id:148, code_postal:'05032', nom:'Beni Foudhala El Hakania', code_wilaya:5},
        {id:149, code_postal:'05033', nom:'Oued El Ma', code_wilaya:5},
        {id:150, code_postal:'05034', nom:'Talkhamt', code_wilaya:5},
        {id:151, code_postal:'05035', nom:'Bouzina', code_wilaya:5},
        {id:152, code_postal:'05036', nom:'Chemora', code_wilaya:5},
        {id:153, code_postal:'05037', nom:'Oued Chaaba', code_wilaya:5},
        {id:154, code_postal:'05038', nom:'Taxlent', code_wilaya:5},
        {id:155, code_postal:'05039', nom:'Gosbat', code_wilaya:5},
        {id:156, code_postal:'05040', nom:'Ouled Aouf', code_wilaya:5},
        {id:157, code_postal:'05041', nom:'Boumagueur', code_wilaya:5},
        {id:158, code_postal:'05042', nom:'Barika', code_wilaya:5},
        {id:159, code_postal:'05043', nom:'Djezzar', code_wilaya:5},
        {id:160, code_postal:'05044', nom:'Tkout', code_wilaya:5},
        {id:161, code_postal:'05045', nom:'Ain Touta', code_wilaya:5},
        {id:162, code_postal:'05046', nom:'Hidoussa', code_wilaya:5},
        {id:163, code_postal:'05047', nom:'Teniet El Abed', code_wilaya:5},
        {id:164, code_postal:'05048', nom:'Oued Taga', code_wilaya:5},
        {id:165, code_postal:'05049', nom:'Ouled Fadel', code_wilaya:5},
        {id:166, code_postal:'05050', nom:'Timgad', code_wilaya:5},
        {id:167, code_postal:'05051', nom:'Ras El Aioun', code_wilaya:5},
        {id:168, code_postal:'05052', nom:'Chir', code_wilaya:5},
        {id:169, code_postal:'05053', nom:'Ouled Si Slimane', code_wilaya:5},
        {id:170, code_postal:'05054', nom:'Zanat El Beida', code_wilaya:5},
        {id:171, code_postal:'05055', nom:'Amdoukal', code_wilaya:5},
        {id:172, code_postal:'05056', nom:'Ouled Ammar', code_wilaya:5},
        {id:173, code_postal:'05057', nom:'El Hassi', code_wilaya:5},
        {id:174, code_postal:'05058', nom:'Lazrou', code_wilaya:5},
        {id:175, code_postal:'05059', nom:'Boumia', code_wilaya:5},
        {id:176, code_postal:'05060', nom:'Boulhilat', code_wilaya:5},
        {id:177, code_postal:'05061', nom:'Larbaa', code_wilaya:5},],
    [{id:0, nom: "Choisir Commune",},
        {id:178, code_postal:'06001', nom:'Bejaia', code_wilaya:6},
        {id:179, code_postal:'06002', nom:'Amizour', code_wilaya:6},
        {id:180, code_postal:'06003', nom:'Ferraoun', code_wilaya:6},
        {id:181, code_postal:'06004', nom:'Taourirt Ighil', code_wilaya:6},
        {id:182, code_postal:'06005', nom:'Chelata', code_wilaya:6},
        {id:183, code_postal:'06006', nom:'Tamokra', code_wilaya:6},
        {id:184, code_postal:'06007', nom:'Timzrit', code_wilaya:6},
        {id:185, code_postal:'06008', nom:'Souk El Thenine', code_wilaya:6},
        {id:186, code_postal:'06009', nom:'Mcisna', code_wilaya:6},
        {id:187, code_postal:'06010', nom:'Thinabdher', code_wilaya:6},
        {id:188, code_postal:'06011', nom:'Tichi', code_wilaya:6},
        {id:189, code_postal:'06012', nom:'Semaoun', code_wilaya:6},
        {id:190, code_postal:'06013', nom:'Kendira', code_wilaya:6},
        {id:191, code_postal:'06014', nom:'Tifra', code_wilaya:6},
        {id:192, code_postal:'06015', nom:'Ighram', code_wilaya:6},
        {id:193, code_postal:'06016', nom:'Amalou', code_wilaya:6},
        {id:194, code_postal:'06017', nom:'Ighil Ali', code_wilaya:6},
        {id:195, code_postal:'06018', nom:'Ifelain Ilmathen', code_wilaya:6},
        {id:196, code_postal:'06019', nom:'Toudja', code_wilaya:6},
        {id:197, code_postal:'06020', nom:'Darguina', code_wilaya:6},
        {id:198, code_postal:'06021', nom:'Sidi Ayad', code_wilaya:6},
        {id:199, code_postal:'06022', nom:'Aokas', code_wilaya:6},
        {id:200, code_postal:'06023', nom:'Beni Djellil', code_wilaya:6},
        {id:201, code_postal:'06024', nom:'Adekar', code_wilaya:6},
        {id:202, code_postal:'06025', nom:'Akbou', code_wilaya:6},
        {id:203, code_postal:'06026', nom:'Seddouk', code_wilaya:6},
        {id:204, code_postal:'06027', nom:'Tazmalt', code_wilaya:6},
        {id:205, code_postal:'06028', nom:'Ait Rizine', code_wilaya:6},
        {id:206, code_postal:'06029', nom:'Chemini', code_wilaya:6},
        {id:207, code_postal:'06030', nom:'Souk Oufella', code_wilaya:6},
        {id:208, code_postal:'06031', nom:'Taskriout', code_wilaya:6},
        {id:209, code_postal:'06032', nom:'Tibane', code_wilaya:6},
        {id:210, code_postal:'06033', nom:'Tala Hamza', code_wilaya:6},
        {id:211, code_postal:'06034', nom:'Barbacha', code_wilaya:6},
        {id:212, code_postal:'06035', nom:'Beni Ksila', code_wilaya:6},
        {id:213, code_postal:'06036', nom:'Ouzallaguen', code_wilaya:6},
        {id:214, code_postal:'06037', nom:'Bouhamza', code_wilaya:6},
        {id:215, code_postal:'06038', nom:'Beni Melikeche', code_wilaya:6},
        {id:216, code_postal:'06039', nom:'Sidi Aich', code_wilaya:6},
        {id:217, code_postal:'06040', nom:'El Kseur', code_wilaya:6},
        {id:218, code_postal:'06041', nom:'Melbou', code_wilaya:6},
        {id:219, code_postal:'06042', nom:'Akfadou', code_wilaya:6},
        {id:220, code_postal:'06043', nom:'Leflaye', code_wilaya:6},
        {id:221, code_postal:'06044', nom:'Kherrata', code_wilaya:6},
        {id:222, code_postal:'06045', nom:'Draa Kaid', code_wilaya:6},
        {id:223, code_postal:'06046', nom:'Tamridjet', code_wilaya:6},
        {id:224, code_postal:'06047', nom:'Ait Smail', code_wilaya:6},
        {id:225, code_postal:'06048', nom:'Boukhelifa', code_wilaya:6},
        {id:226, code_postal:'06049', nom:'Tizi Nberber', code_wilaya:6},
        {id:227, code_postal:'06050', nom:'Beni Maouch', code_wilaya:6},
        {id:228, code_postal:'06051', nom:'Oued Ghir', code_wilaya:6},
        {id:229, code_postal:'06052', nom:'Boudjellil', code_wilaya:6},],
    [{id:0, nom: "Choisir Commune",},
        {id:230, code_postal:'07001', nom:'Biskra', code_wilaya:7},
        {id:231, code_postal:'07002', nom:'Oumache', code_wilaya:7},
        {id:232, code_postal:'07003', nom:'Branis', code_wilaya:7},
        {id:233, code_postal:'07004', nom:'Chetma', code_wilaya:7},
        {id:234, code_postal:'07005', nom:'Ouled Djellal', code_wilaya:7},
        {id:235, code_postal:'07006', nom:'Ras El Miaad', code_wilaya:7},
        {id:236, code_postal:'07007', nom:'Besbes', code_wilaya:7},
        {id:237, code_postal:'07008', nom:'Sidi Khaled', code_wilaya:7},
        {id:238, code_postal:'07009', nom:'Doucen', code_wilaya:7},
        {id:239, code_postal:'07010', nom:'Ech Chaiba', code_wilaya:7},
        {id:240, code_postal:'07011', nom:'Sidi Okba', code_wilaya:7},
        {id:241, code_postal:'07012', nom:'Mchouneche', code_wilaya:7},
        {id:242, code_postal:'07013', nom:'El Haouch', code_wilaya:7},
        {id:243, code_postal:'07014', nom:'Ain Naga', code_wilaya:7},
        {id:244, code_postal:'07015', nom:'Zeribet El Oued', code_wilaya:7},
        {id:245, code_postal:'07016', nom:'El Feidh', code_wilaya:7},
        {id:246, code_postal:'07017', nom:'El Kantara', code_wilaya:7},
        {id:247, code_postal:'07018', nom:'Ain Zaatout', code_wilaya:7},
        {id:248, code_postal:'07019', nom:'El Outaya', code_wilaya:7},
        {id:249, code_postal:'07020', nom:'Djemorah', code_wilaya:7},
        {id:250, code_postal:'07021', nom:'Tolga', code_wilaya:7},
        {id:251, code_postal:'07022', nom:'Lioua', code_wilaya:7},
        {id:252, code_postal:'07023', nom:'Lichana', code_wilaya:7},
        {id:253, code_postal:'07024', nom:'Ourlal', code_wilaya:7},
        {id:254, code_postal:'07025', nom:'Mlili', code_wilaya:7},
        {id:255, code_postal:'07026', nom:'Foughala', code_wilaya:7},
        {id:256, code_postal:'07027', nom:'Bordj Ben Azzouz', code_wilaya:7},
        {id:257, code_postal:'07028', nom:'Meziraa', code_wilaya:7},
        {id:258, code_postal:'07029', nom:'Bouchagroun', code_wilaya:7},
        {id:259, code_postal:'07030', nom:'Mekhadma', code_wilaya:7},
        {id:260, code_postal:'07031', nom:'El Ghrous', code_wilaya:7},
        {id:261, code_postal:'07032', nom:'El Hadjab', code_wilaya:7},
        {id:262, code_postal:'07033', nom:'Khanguet Sidinadji', code_wilaya:7},],
    [{id:0, nom: "Choisir Commune",},
        {id:263, code_postal:'08001', nom:'Bechar', code_wilaya:8},
        {id:264, code_postal:'08002', nom:'Erg Ferradj', code_wilaya:8},
        {id:265, code_postal:'08003', nom:'Ouled Khoudir', code_wilaya:8},
        {id:266, code_postal:'08004', nom:'Meridja', code_wilaya:8},
        {id:267, code_postal:'08005', nom:'Timoudi', code_wilaya:8},
        {id:268, code_postal:'08006', nom:'Lahmar', code_wilaya:8},
        {id:269, code_postal:'08007', nom:'Beni Abbes', code_wilaya:8},
        {id:270, code_postal:'08008', nom:'Beni Ikhlef', code_wilaya:8},
        {id:271, code_postal:'08009', nom:'Mechraa Houari B', code_wilaya:8},
        {id:272, code_postal:'08010', nom:'Kenedsa', code_wilaya:8},
        {id:273, code_postal:'08011', nom:'Igli', code_wilaya:8},
        {id:274, code_postal:'08012', nom:'Tabalbala', code_wilaya:8},
        {id:275, code_postal:'08013', nom:'Taghit', code_wilaya:8},
        {id:276, code_postal:'08014', nom:'El Ouata', code_wilaya:8},
        {id:277, code_postal:'08015', nom:'Boukais', code_wilaya:8},
        {id:278, code_postal:'08016', nom:'Mogheul', code_wilaya:8},
        {id:279, code_postal:'08017', nom:'Abadla', code_wilaya:8},
        {id:280, code_postal:'08018', nom:'Kerzaz', code_wilaya:8},
        {id:281, code_postal:'08019', nom:'Ksabi', code_wilaya:8},
        {id:282, code_postal:'08020', nom:'Tamtert', code_wilaya:8},
        {id:283, code_postal:'08021', nom:'Beni Ounif', code_wilaya:8},],
    [{id:0, nom: "Choisir Commune",},
        {id:284, code_postal:'09001', nom:'Blida', code_wilaya:9},
        {id:285, code_postal:'09002', nom:'Chebli', code_wilaya:9},
        {id:286, code_postal:'09003', nom:'Bouinan', code_wilaya:9},
        {id:287, code_postal:'09004', nom:'Oued El Alleug', code_wilaya:9},
        {id:288, code_postal:'09007', nom:'Ouled Yaich', code_wilaya:9},
        {id:289, code_postal:'09008', nom:'Chrea', code_wilaya:9},
        {id:290, code_postal:'09010', nom:'El Affroun', code_wilaya:9},
        {id:291, code_postal:'09011', nom:'Chiffa', code_wilaya:9},
        {id:292, code_postal:'09012', nom:'Hammam Melouane', code_wilaya:9},
        {id:293, code_postal:'09013', nom:'Ben Khlil', code_wilaya:9},
        {id:294, code_postal:'09014', nom:'Soumaa', code_wilaya:9},
        {id:295, code_postal:'09016', nom:'Mouzaia', code_wilaya:9},
        {id:296, code_postal:'09017', nom:'Souhane', code_wilaya:9},
        {id:297, code_postal:'09018', nom:'Meftah', code_wilaya:9},
        {id:298, code_postal:'09019', nom:'Ouled Selama', code_wilaya:9},
        {id:299, code_postal:'09020', nom:'Boufarik', code_wilaya:9},
        {id:300, code_postal:'09021', nom:'Larbaa', code_wilaya:9},
        {id:301, code_postal:'09022', nom:'Oued Djer', code_wilaya:9},
        {id:302, code_postal:'09023', nom:'Beni Tamou', code_wilaya:9},
        {id:303, code_postal:'09024', nom:'Bouarfa', code_wilaya:9},
        {id:304, code_postal:'09025', nom:'Beni Mered', code_wilaya:9},
        {id:305, code_postal:'09026', nom:'Bougara', code_wilaya:9},
        {id:306, code_postal:'09027', nom:'Guerrouaou', code_wilaya:9},
        {id:307, code_postal:'09028', nom:'Ain Romana', code_wilaya:9},
        {id:308, code_postal:'09029', nom:'Djebabra', code_wilaya:9},],
    [{id:0, nom: "Choisir Commune",},
        {id:309, code_postal:'10001', nom:'Bouira', code_wilaya:10},
        {id:310, code_postal:'10002', nom:'El Asnam', code_wilaya:10},
        {id:311, code_postal:'10003', nom:'Guerrouma', code_wilaya:10},
        {id:312, code_postal:'10004', nom:'Souk El Khemis', code_wilaya:10},
        {id:313, code_postal:'10005', nom:'Kadiria', code_wilaya:10},
        {id:314, code_postal:'10006', nom:'Hanif', code_wilaya:10},
        {id:315, code_postal:'10007', nom:'Dirah', code_wilaya:10},
        {id:316, code_postal:'10008', nom:'Ait Laaziz', code_wilaya:10},
        {id:317, code_postal:'10009', nom:'Taghzout', code_wilaya:10},
        {id:318, code_postal:'10010', nom:'Raouraoua', code_wilaya:10},
        {id:319, code_postal:'10011', nom:'Mezdour', code_wilaya:10},
        {id:320, code_postal:'10012', nom:'Haizer', code_wilaya:10},
        {id:321, code_postal:'10013', nom:'Lakhdaria', code_wilaya:10},
        {id:322, code_postal:'10014', nom:'Maala', code_wilaya:10},
        {id:323, code_postal:'10015', nom:'El Hachimia', code_wilaya:10},
        {id:324, code_postal:'10016', nom:'Aomar', code_wilaya:10},
        {id:325, code_postal:'10017', nom:'Chorfa', code_wilaya:10},
        {id:326, code_postal:'10018', nom:'Bordj Oukhriss', code_wilaya:10},
        {id:327, code_postal:'10019', nom:'El Adjiba', code_wilaya:10},
        {id:328, code_postal:'10020', nom:'El Hakimia', code_wilaya:10},
        {id:329, code_postal:'10021', nom:'El Khebouzia', code_wilaya:10},
        {id:330, code_postal:'10022', nom:'Ahl El Ksar', code_wilaya:10},
        {id:331, code_postal:'10023', nom:'Bouderbala', code_wilaya:10},
        {id:332, code_postal:'10024', nom:'Zbarbar', code_wilaya:10},
        {id:333, code_postal:'10025', nom:'Ain El Hadjar', code_wilaya:10},
        {id:334, code_postal:'10026', nom:'Djebahia', code_wilaya:10},
        {id:335, code_postal:'10027', nom:'Aghbalou', code_wilaya:10},
        {id:336, code_postal:'10028', nom:'Taguedit', code_wilaya:10},
        {id:337, code_postal:'10029', nom:'Ain Turk', code_wilaya:10},
        {id:338, code_postal:'10030', nom:'Saharidj', code_wilaya:10},
        {id:339, code_postal:'10031', nom:'Dechmia', code_wilaya:10},
        {id:340, code_postal:'10032', nom:'Ridane', code_wilaya:10},
        {id:341, code_postal:'10033', nom:'Bechloul', code_wilaya:10},
        {id:342, code_postal:'10034', nom:'Boukram', code_wilaya:10},
        {id:343, code_postal:'10035', nom:'Ain Bessam', code_wilaya:10},
        {id:344, code_postal:'10036', nom:'Bir Ghbalou', code_wilaya:10},
        {id:345, code_postal:'10037', nom:'Mchedallah', code_wilaya:10},
        {id:346, code_postal:'10038', nom:'Sour El Ghozlane', code_wilaya:10},
        {id:347, code_postal:'10039', nom:'Maamora', code_wilaya:10},
        {id:348, code_postal:'10040', nom:'Ouled Rached', code_wilaya:10},
        {id:349, code_postal:'10041', nom:'Ain Laloui', code_wilaya:10},
        {id:350, code_postal:'10042', nom:'Hadjera Zerga', code_wilaya:10},
        {id:351, code_postal:'10043', nom:'Ath Mansour', code_wilaya:10},
        {id:352, code_postal:'10044', nom:'El Mokrani', code_wilaya:10},
        {id:353, code_postal:'10045', nom:'Oued El Berdi', code_wilaya:10},],
    [{id:0, nom: "Choisir Commune",},
        {id:354, code_postal:'11001', nom:'Tamanghasset', code_wilaya:11},
        {id:355, code_postal:'11002', nom:'Abalessa', code_wilaya:11},
        {id:356, code_postal:'11003', nom:'In Ghar', code_wilaya:11},
        {id:357, code_postal:'11004', nom:'In Guezzam', code_wilaya:11},
        {id:358, code_postal:'11005', nom:'Idles', code_wilaya:11},
        {id:359, code_postal:'11006', nom:'Tazouk', code_wilaya:11},
        {id:360, code_postal:'11007', nom:'Tinzaouatine', code_wilaya:11},
        {id:361, code_postal:'11008', nom:'In Salah', code_wilaya:11},
        {id:362, code_postal:'11009', nom:'In Amguel', code_wilaya:11},
        {id:363, code_postal:'11010', nom:'Foggaret Ezzaouia', code_wilaya:11},],
    [{id:0, nom: "Choisir Commune",},
        {id:364, code_postal:'12001', nom:'Tebessa', code_wilaya:12},
        {id:365, code_postal:'12002', nom:'Bir El Ater', code_wilaya:12},
        {id:366, code_postal:'12003', nom:'Cheria', code_wilaya:12},
        {id:367, code_postal:'12004', nom:'Stah Guentis', code_wilaya:12},
        {id:368, code_postal:'12005', nom:'El Aouinet', code_wilaya:12},
        {id:369, code_postal:'12006', nom:'Lahouidjbet', code_wilaya:12},
        {id:370, code_postal:'12007', nom:'Safsaf El Ouesra', code_wilaya:12},
        {id:371, code_postal:'12008', nom:'Hammamet', code_wilaya:12},
        {id:372, code_postal:'12009', nom:'Negrine', code_wilaya:12},
        {id:373, code_postal:'12010', nom:'Bir El Mokadem', code_wilaya:12},
        {id:374, code_postal:'12011', nom:'El Kouif', code_wilaya:12},
        {id:375, code_postal:'12012', nom:'Morsott', code_wilaya:12},
        {id:376, code_postal:'12013', nom:'El Ogla', code_wilaya:12},
        {id:377, code_postal:'12014', nom:'Bir Dheheb', code_wilaya:12},
        {id:378, code_postal:'12015', nom:'El Ogla El Malha', code_wilaya:12},
        {id:379, code_postal:'12016', nom:'Gorriguer', code_wilaya:12},
        {id:380, code_postal:'12017', nom:'Bekkaria', code_wilaya:12},
        {id:381, code_postal:'12018', nom:'Boukhadra', code_wilaya:12},
        {id:382, code_postal:'12019', nom:'Ouenza', code_wilaya:12},
        {id:383, code_postal:'12020', nom:'El Ma El Biodh', code_wilaya:12},
        {id:384, code_postal:'12021', nom:'Oum Ali', code_wilaya:12},
        {id:385, code_postal:'12022', nom:'Thlidjene', code_wilaya:12},
        {id:386, code_postal:'12023', nom:'Ain Zerga', code_wilaya:12},
        {id:387, code_postal:'12024', nom:'El Meridj', code_wilaya:12},
        {id:388, code_postal:'12025', nom:'Boulhaf Dyr', code_wilaya:12},
        {id:389, code_postal:'12026', nom:'Bedjene', code_wilaya:12},
        {id:390, code_postal:'12027', nom:'El Mazeraa', code_wilaya:12},
        {id:391, code_postal:'12028', nom:'Ferkane', code_wilaya:12},],
    [{id:0, nom: "Choisir Commune",},
        {id:392, code_postal:'13001', nom:'Tlemcen', code_wilaya:13},
        {id:393, code_postal:'13002', nom:'Beni Mester', code_wilaya:13},
        {id:394, code_postal:'13003', nom:'Ain Tallout', code_wilaya:13},
        {id:395, code_postal:'13004', nom:'Remchi', code_wilaya:13},
        {id:396, code_postal:'13005', nom:'El Fehoul', code_wilaya:13},
        {id:397, code_postal:'13006', nom:'Sabra', code_wilaya:13},
        {id:398, code_postal:'13007', nom:'Ghazaouet', code_wilaya:13},
        {id:399, code_postal:'13008', nom:'Souani', code_wilaya:13},
        {id:400, code_postal:'13009', nom:'Djebala', code_wilaya:13},
        {id:401, code_postal:'13010', nom:'El Gor', code_wilaya:13},
        {id:402, code_postal:'13011', nom:'Oued Chouly', code_wilaya:13},
        {id:403, code_postal:'13012', nom:'Ain Fezza', code_wilaya:13},
        {id:404, code_postal:'13013', nom:'Ouled Mimoun', code_wilaya:13},
        {id:405, code_postal:'13014', nom:'Amieur', code_wilaya:13},
        {id:406, code_postal:'13015', nom:'Ain Youcef', code_wilaya:13},
        {id:407, code_postal:'13016', nom:'Zenata', code_wilaya:13},
        {id:408, code_postal:'13017', nom:'Beni Snous', code_wilaya:13},
        {id:409, code_postal:'13018', nom:'Bab El Assa', code_wilaya:13},
        {id:410, code_postal:'13019', nom:'Dar Yaghmouracene', code_wilaya:13},
        {id:411, code_postal:'13020', nom:'Fellaoucene', code_wilaya:13},
        {id:412, code_postal:'13021', nom:'Azails', code_wilaya:13},
        {id:413, code_postal:'13022', nom:'Sebbaa Chioukh', code_wilaya:13},
        {id:414, code_postal:'13023', nom:'Terni Beni Hediel', code_wilaya:13},
        {id:415, code_postal:'13024', nom:'Bensekrane', code_wilaya:13},
        {id:416, code_postal:'13025', nom:'Ain Nehala', code_wilaya:13},
        {id:417, code_postal:'13026', nom:'Hennaya', code_wilaya:13},
        {id:418, code_postal:'13027', nom:'Maghnia', code_wilaya:13},
        {id:419, code_postal:'13028', nom:'Hammam Boughrara', code_wilaya:13},
        {id:420, code_postal:'13029', nom:'Souahlia', code_wilaya:13},
        {id:421, code_postal:'13030', nom:'Msirda Fouaga', code_wilaya:13},
        {id:422, code_postal:'13031', nom:'Ain Fetah', code_wilaya:13},
        {id:423, code_postal:'13032', nom:'El Aricha', code_wilaya:13},
        {id:424, code_postal:'13033', nom:'Souk Thlata', code_wilaya:13},
        {id:425, code_postal:'13034', nom:'Sidi Abdelli', code_wilaya:13},
        {id:426, code_postal:'13035', nom:'Sebdou', code_wilaya:13},
        {id:427, code_postal:'13036', nom:'Beni Ouarsous', code_wilaya:13},
        {id:428, code_postal:'13037', nom:'Sidi Medjahed', code_wilaya:13},
        {id:429, code_postal:'13038', nom:'Beni Boussaid', code_wilaya:13},
        {id:430, code_postal:'13039', nom:'Marsa Ben Mhidi', code_wilaya:13},
        {id:431, code_postal:'13040', nom:'Nedroma', code_wilaya:13},
        {id:432, code_postal:'13041', nom:'Sidi Djillali', code_wilaya:13},
        {id:433, code_postal:'13042', nom:'Beni Bahdel', code_wilaya:13},
        {id:434, code_postal:'13043', nom:'El Bouihi', code_wilaya:13},
        {id:435, code_postal:'13044', nom:'Honaine', code_wilaya:13},
        {id:436, code_postal:'13045', nom:'Tianet', code_wilaya:13},
        {id:437, code_postal:'13046', nom:'Ouled Riyah', code_wilaya:13},
        {id:438, code_postal:'13047', nom:'Bouhlou', code_wilaya:13},
        {id:439, code_postal:'13048', nom:'Souk El Khemis', code_wilaya:13},
        {id:440, code_postal:'13049', nom:'Ain Ghoraba', code_wilaya:13},
        {id:441, code_postal:'13050', nom:'Chetouane', code_wilaya:13},
        {id:442, code_postal:'13051', nom:'Mansourah', code_wilaya:13},
        {id:443, code_postal:'13052', nom:'Beni Semiel', code_wilaya:13},
        {id:444, code_postal:'13053', nom:'Ain Kebira', code_wilaya:13},],
    [{id:0, nom: "Choisir Commune",},
        {id:445, code_postal:'14001', nom:'Tiaret', code_wilaya:14},
        {id:446, code_postal:'14002', nom:'Medroussa', code_wilaya:14},
        {id:447, code_postal:'14003', nom:'Ain Bouchekif', code_wilaya:14},
        {id:448, code_postal:'14004', nom:'Sidi Ali Mellal', code_wilaya:14},
        {id:449, code_postal:'14005', nom:'Ain Zarit', code_wilaya:14},
        {id:450, code_postal:'14006', nom:'Ain Deheb', code_wilaya:14},
        {id:451, code_postal:'14007', nom:'Sidi Bakhti', code_wilaya:14},
        {id:452, code_postal:'14008', nom:'Medrissa', code_wilaya:14},
        {id:453, code_postal:'14009', nom:'Zmalet El Emir Aek', code_wilaya:14},
        {id:454, code_postal:'14010', nom:'Madna', code_wilaya:14},
        {id:455, code_postal:'14011', nom:'Sebt', code_wilaya:14},
        {id:456, code_postal:'14012', nom:'Mellakou', code_wilaya:14},
        {id:457, code_postal:'14013', nom:'Dahmouni', code_wilaya:14},
        {id:458, code_postal:'14014', nom:'Rahouia', code_wilaya:14},
        {id:459, code_postal:'14015', nom:'Mahdia', code_wilaya:14},
        {id:460, code_postal:'14016', nom:'Sougueur', code_wilaya:14},
        {id:461, code_postal:'14017', nom:'Sidi Abdelghani', code_wilaya:14},
        {id:462, code_postal:'14018', nom:'Ain El Hadid', code_wilaya:14},
        {id:463, code_postal:'14019', nom:'Ouled Djerad', code_wilaya:14},
        {id:464, code_postal:'14020', nom:'Naima', code_wilaya:14},
        {id:465, code_postal:'14021', nom:'Meghila', code_wilaya:14},
        {id:466, code_postal:'14022', nom:'Guertoufa', code_wilaya:14},
        {id:467, code_postal:'14023', nom:'Sidi Hosni', code_wilaya:14},
        {id:468, code_postal:'14024', nom:'Djillali Ben Amar', code_wilaya:14},
        {id:469, code_postal:'14025', nom:'Sebaine', code_wilaya:14},
        {id:470, code_postal:'14026', nom:'Tousnina', code_wilaya:14},
        {id:471, code_postal:'14027', nom:'Frenda', code_wilaya:14},
        {id:472, code_postal:'14028', nom:'Ain Kermes', code_wilaya:14},
        {id:473, code_postal:'14029', nom:'Ksar Chellala', code_wilaya:14},
        {id:474, code_postal:'14030', nom:'Rechaiga', code_wilaya:14},
        {id:475, code_postal:'14031', nom:'Nadorah', code_wilaya:14},
        {id:476, code_postal:'14032', nom:'Tagdemt', code_wilaya:14},
        {id:477, code_postal:'14033', nom:'Oued Lilli', code_wilaya:14},
        {id:478, code_postal:'14034', nom:'Mechraa Safa', code_wilaya:14},
        {id:479, code_postal:'14035', nom:'Hamadia', code_wilaya:14},
        {id:480, code_postal:'14036', nom:'Chehaima', code_wilaya:14},
        {id:481, code_postal:'14037', nom:'Takhemaret', code_wilaya:14},
        {id:482, code_postal:'14038', nom:'Sidi Abderrahmane', code_wilaya:14},
        {id:483, code_postal:'14039', nom:'Serghine', code_wilaya:14},
        {id:484, code_postal:'14040', nom:'Bougara', code_wilaya:14},
        {id:485, code_postal:'14041', nom:'Faidja', code_wilaya:14},
        {id:486, code_postal:'14042', nom:'Tidda', code_wilaya:14},],
    [{id:0, nom: "Choisir Commune",},
        {id:487, code_postal:'15001', nom:'Tizi Ouzou', code_wilaya:15},
        {id:488, code_postal:'15002', nom:'Ain El Hammam', code_wilaya:15},
        {id:489, code_postal:'15003', nom:'Akbil', code_wilaya:15},
        {id:490, code_postal:'15004', nom:'Freha', code_wilaya:15},
        {id:491, code_postal:'15005', nom:'Souamaa', code_wilaya:15},
        {id:492, code_postal:'15006', nom:'Mechtrass', code_wilaya:15},
        {id:493, code_postal:'15007', nom:'Irdjen', code_wilaya:15},
        {id:494, code_postal:'15008', nom:'Timizart', code_wilaya:15},
        {id:495, code_postal:'15009', nom:'Makouda', code_wilaya:15},
        {id:496, code_postal:'15010', nom:'Draa El Mizan', code_wilaya:15},
        {id:497, code_postal:'15011', nom:'Tizi Ghenif', code_wilaya:15},
        {id:498, code_postal:'15012', nom:'Bounouh', code_wilaya:15},
        {id:499, code_postal:'15013', nom:'Ait Chaffaa', code_wilaya:15},
        {id:500, code_postal:'15014', nom:'Frikat', code_wilaya:15},
        {id:501, code_postal:'15015', nom:'Beni Aissi', code_wilaya:15},
        {id:502, code_postal:'15016', nom:'Beni Zmenzer', code_wilaya:15},
        {id:503, code_postal:'15017', nom:'Iferhounene', code_wilaya:15},
        {id:504, code_postal:'15018', nom:'Azazga', code_wilaya:15},
        {id:505, code_postal:'15019', nom:'Iloula Oumalou', code_wilaya:15},
        {id:506, code_postal:'15020', nom:'Yakouren', code_wilaya:15},
        {id:507, code_postal:'15021', nom:'Larba Nait Irathen', code_wilaya:15},
        {id:508, code_postal:'15022', nom:'Tizi Rached', code_wilaya:15},
        {id:509, code_postal:'15023', nom:'Zekri', code_wilaya:15},
        {id:510, code_postal:'15024', nom:'Ouaguenoun', code_wilaya:15},
        {id:511, code_postal:'15025', nom:'Ain Zaouia', code_wilaya:15},
        {id:512, code_postal:'15026', nom:'Mkira', code_wilaya:15},
        {id:513, code_postal:'15027', nom:'Ait Yahia', code_wilaya:15},
        {id:514, code_postal:'15028', nom:'Ait Mahmoud', code_wilaya:15},
        {id:515, code_postal:'15029', nom:'Maatka', code_wilaya:15},
        {id:516, code_postal:'15030', nom:'Ait Boumehdi', code_wilaya:15},
        {id:517, code_postal:'15031', nom:'Abi Youcef', code_wilaya:15},
        {id:518, code_postal:'15032', nom:'Beni Douala', code_wilaya:15},
        {id:519, code_postal:'15033', nom:'Illilten', code_wilaya:15},
        {id:520, code_postal:'15034', nom:'Bouzguen', code_wilaya:15},
        {id:521, code_postal:'15035', nom:'Ait Aggouacha', code_wilaya:15},
        {id:522, code_postal:'15036', nom:'Ouadhia', code_wilaya:15},
        {id:523, code_postal:'15037', nom:'Azzefoun', code_wilaya:15},
        {id:524, code_postal:'15038', nom:'Tigzirt', code_wilaya:15},
        {id:525, code_postal:'15039', nom:'Ait Aissa Mimoun', code_wilaya:15},
        {id:526, code_postal:'15040', nom:'Boghni', code_wilaya:15},
        {id:527, code_postal:'15041', nom:'Ifigha', code_wilaya:15},
        {id:528, code_postal:'15042', nom:'Ait Oumalou', code_wilaya:15},
        {id:529, code_postal:'15043', nom:'Tirmitine', code_wilaya:15},
        {id:530, code_postal:'15044', nom:'Akerrou', code_wilaya:15},
        {id:531, code_postal:'15045', nom:'Yatafen', code_wilaya:15},
        {id:532, code_postal:'15046', nom:'Beni Ziki', code_wilaya:15},
        {id:533, code_postal:'15047', nom:'Draa Ben Khedda', code_wilaya:15},
        {id:534, code_postal:'15048', nom:'Ouacif', code_wilaya:15},
        {id:535, code_postal:'15049', nom:'Idjeur', code_wilaya:15},
        {id:536, code_postal:'15050', nom:'Mekla', code_wilaya:15},
        {id:537, code_postal:'15051', nom:'Tizi Nthlata', code_wilaya:15},
        {id:538, code_postal:'15052', nom:'Beni Yenni', code_wilaya:15},
        {id:539, code_postal:'15053', nom:'Aghrib', code_wilaya:15},
        {id:540, code_postal:'15054', nom:'Iflissen', code_wilaya:15},
        {id:541, code_postal:'15055', nom:'Boudjima', code_wilaya:15},
        {id:542, code_postal:'15056', nom:'Ait Yahia Moussa', code_wilaya:15},
        {id:543, code_postal:'15057', nom:'Souk El Thenine', code_wilaya:15},
        {id:544, code_postal:'15058', nom:'Ait Khelil', code_wilaya:15},
        {id:545, code_postal:'15059', nom:'Sidi Naamane', code_wilaya:15},
        {id:546, code_postal:'15060', nom:'Iboudraren', code_wilaya:15},
        {id:547, code_postal:'15061', nom:'Aghni Goughran', code_wilaya:15},
        {id:548, code_postal:'15062', nom:'Mizrana', code_wilaya:15},
        {id:549, code_postal:'15063', nom:'Imsouhal', code_wilaya:15},
        {id:550, code_postal:'15064', nom:'Tadmait', code_wilaya:15},
        {id:551, code_postal:'15065', nom:'Ait Bouadou', code_wilaya:15},
        {id:552, code_postal:'15066', nom:'Assi Youcef', code_wilaya:15},
        {id:553, code_postal:'15067', nom:'Ait Toudert', code_wilaya:15},],
    [{id:0, nom: "Choisir Commune",},
        {id:554, code_postal:'16001', nom:'Alger Centre', code_wilaya:16},
        {id:555, code_postal:'16002', nom:'Sidi Mhamed', code_wilaya:16},
        {id:556, code_postal:'16003', nom:'El Madania', code_wilaya:16},
        {id:557, code_postal:'16004', nom:'Hamma Anassers', code_wilaya:16},
        {id:558, code_postal:'16005', nom:'Bab El Oued', code_wilaya:16},
        {id:559, code_postal:'16006', nom:'Bologhine Ibn Ziri', code_wilaya:16},
        {id:560, code_postal:'16007', nom:'Casbah', code_wilaya:16},
        {id:561, code_postal:'16008', nom:'Oued Koriche', code_wilaya:16},
        {id:562, code_postal:'16009', nom:'Bir Mourad Rais', code_wilaya:16},
        {id:563, code_postal:'16010', nom:'El Biar', code_wilaya:16},
        {id:564, code_postal:'16011', nom:'Bouzareah', code_wilaya:16},
        {id:565, code_postal:'16012', nom:'Birkhadem', code_wilaya:16},
        {id:566, code_postal:'16013', nom:'El Harrach', code_wilaya:16},
        {id:567, code_postal:'16014', nom:'Baraki', code_wilaya:16},
        {id:568, code_postal:'16015', nom:'Oued Smar', code_wilaya:16},
        {id:569, code_postal:'16016', nom:'Bourouba', code_wilaya:16},
        {id:570, code_postal:'16017', nom:'Hussein Dey', code_wilaya:16},
        {id:571, code_postal:'16018', nom:'Kouba', code_wilaya:16},
        {id:572, code_postal:'16019', nom:'Bachedjerah', code_wilaya:16},
        {id:573, code_postal:'16020', nom:'Dar El Beida', code_wilaya:16},
        {id:574, code_postal:'16021', nom:'Bab Azzouar', code_wilaya:16},
        {id:575, code_postal:'16022', nom:'Ben Aknoun', code_wilaya:16},
        {id:576, code_postal:'16023', nom:'Dely Ibrahim', code_wilaya:16},
        {id:577, code_postal:'16024', nom:'Bains Romains', code_wilaya:16},
        {id:578, code_postal:'16025', nom:'Rais Hamidou', code_wilaya:16},
        {id:579, code_postal:'16026', nom:'Djasr Kasentina', code_wilaya:16},
        {id:580, code_postal:'16027', nom:'El Mouradia', code_wilaya:16},
        {id:581, code_postal:'16028', nom:'Hydra', code_wilaya:16},
        {id:582, code_postal:'16029', nom:'Mohammadia', code_wilaya:16},
        {id:583, code_postal:'16030', nom:'Bordj El Kiffan', code_wilaya:16},
        {id:584, code_postal:'16031', nom:'El Magharia', code_wilaya:16},
        {id:585, code_postal:'16032', nom:'Beni Messous', code_wilaya:16},
        {id:586, code_postal:'16033', nom:'Les Eucalyptus', code_wilaya:16},
        {id:587, code_postal:'16034', nom:'Birtouta', code_wilaya:16},
        {id:588, code_postal:'16035', nom:'Tassala El Merdja', code_wilaya:16},
        {id:589, code_postal:'16036', nom:'Ouled Chebel', code_wilaya:16},
        {id:590, code_postal:'16037', nom:'Sidi Moussa', code_wilaya:16},
        {id:591, code_postal:'16038', nom:'Ain Taya', code_wilaya:16},
        {id:592, code_postal:'16039', nom:'Bordj El Bahri', code_wilaya:16},
        {id:593, code_postal:'16040', nom:'Marsa', code_wilaya:16},
        {id:594, code_postal:'16041', nom:'Haraoua', code_wilaya:16},
        {id:595, code_postal:'16042', nom:'Rouiba', code_wilaya:16},
        {id:596, code_postal:'16043', nom:'Reghaia', code_wilaya:16},
        {id:597, code_postal:'16044', nom:'Ain Benian', code_wilaya:16},
        {id:598, code_postal:'16045', nom:'Staoueli', code_wilaya:16},
        {id:599, code_postal:'16046', nom:'Zeralda', code_wilaya:16},
        {id:600, code_postal:'16047', nom:'Mahelma', code_wilaya:16},
        {id:601, code_postal:'16048', nom:'Rahmania', code_wilaya:16},
        {id:602, code_postal:'16049', nom:'Souidania', code_wilaya:16},
        {id:603, code_postal:'16050', nom:'Cheraga', code_wilaya:16},
        {id:604, code_postal:'16051', nom:'Ouled Fayet', code_wilaya:16},
        {id:605, code_postal:'16052', nom:'El Achour', code_wilaya:16},
        {id:606, code_postal:'16053', nom:'Draria', code_wilaya:16},
        {id:607, code_postal:'16054', nom:'Douera', code_wilaya:16},
        {id:608, code_postal:'16055', nom:'Baba Hassen', code_wilaya:16},
        {id:609, code_postal:'16056', nom:'Khracia', code_wilaya:16},
        {id:610, code_postal:'16057', nom:'Saoula', code_wilaya:16},],
    [{id:0, nom: "Choisir Commune",},
        {id:611, code_postal:'17001', nom:'Djelfa', code_wilaya:17},
        {id:612, code_postal:'17002', nom:'Moudjebara', code_wilaya:17},
        {id:613, code_postal:'17003', nom:'El Guedid', code_wilaya:17},
        {id:614, code_postal:'17004', nom:'Hassi Bahbah', code_wilaya:17},
        {id:615, code_postal:'17005', nom:'Ain Maabed', code_wilaya:17},
        {id:616, code_postal:'17006', nom:'Sed Rahal', code_wilaya:17},
        {id:617, code_postal:'17007', nom:'Feidh El Botma', code_wilaya:17},
        {id:618, code_postal:'17008', nom:'Birine', code_wilaya:17},
        {id:619, code_postal:'17009', nom:'Bouira Lahdeb', code_wilaya:17},
        {id:620, code_postal:'17010', nom:'Zaccar', code_wilaya:17},
        {id:621, code_postal:'17011', nom:'El Khemis', code_wilaya:17},
        {id:622, code_postal:'17012', nom:'Sidi Baizid', code_wilaya:17},
        {id:623, code_postal:'17013', nom:'Mliliha', code_wilaya:17},
        {id:624, code_postal:'17014', nom:'El Idrissia', code_wilaya:17},
        {id:625, code_postal:'17015', nom:'Douis', code_wilaya:17},
        {id:626, code_postal:'17016', nom:'Hassi El Euch', code_wilaya:17},
        {id:627, code_postal:'17017', nom:'Messaad', code_wilaya:17},
        {id:628, code_postal:'17018', nom:'Guettara', code_wilaya:17},
        {id:629, code_postal:'17019', nom:'Sidi Ladjel', code_wilaya:17},
        {id:630, code_postal:'17020', nom:'Had Sahary', code_wilaya:17},
        {id:631, code_postal:'17021', nom:'Guernini', code_wilaya:17},
        {id:632, code_postal:'17022', nom:'Selmana', code_wilaya:17},
        {id:633, code_postal:'17023', nom:'Ain Chouhada', code_wilaya:17},
        {id:634, code_postal:'17024', nom:'Oum Laadham', code_wilaya:17},
        {id:635, code_postal:'17025', nom:'Dar Chouikh', code_wilaya:17},
        {id:636, code_postal:'17026', nom:'Charef', code_wilaya:17},
        {id:637, code_postal:'17027', nom:'Beni Yacoub', code_wilaya:17},
        {id:638, code_postal:'17028', nom:'Zaafrane', code_wilaya:17},
        {id:639, code_postal:'17029', nom:'Deldoul', code_wilaya:17},
        {id:640, code_postal:'17030', nom:'Ain El Ibel', code_wilaya:17},
        {id:641, code_postal:'17031', nom:'Ain Oussera', code_wilaya:17},
        {id:642, code_postal:'17032', nom:'Benhar', code_wilaya:17},
        {id:643, code_postal:'17033', nom:'Hassi Fedoul', code_wilaya:17},
        {id:644, code_postal:'17034', nom:'Amourah', code_wilaya:17},
        {id:645, code_postal:'17035', nom:'Ain Fekka', code_wilaya:17},
        {id:646, code_postal:'17036', nom:'Tadmit', code_wilaya:17},],
    [{id:0, nom: "Choisir Commune",},
         {id:647, code_postal:'18001', nom:'Jijel', code_wilaya:18},
        {id:648, code_postal:'18002', nom:'Erraguene', code_wilaya:18},
        {id:649, code_postal:'18003', nom:'El Aouana', code_wilaya:18},
        {id:650, code_postal:'18004', nom:'Ziamma Mansouriah', code_wilaya:18},
        {id:651, code_postal:'18005', nom:'Taher', code_wilaya:18},
        {id:652, code_postal:'18006', nom:'Emir Abdelkader', code_wilaya:18},
        {id:653, code_postal:'18007', nom:'Chekfa', code_wilaya:18},
        {id:654, code_postal:'18008', nom:'Chahna', code_wilaya:18},
        {id:655, code_postal:'18009', nom:'El Milia', code_wilaya:18},
        {id:656, code_postal:'18010', nom:'Sidi Maarouf', code_wilaya:18},
        {id:657, code_postal:'18011', nom:'Settara', code_wilaya:18},
        {id:658, code_postal:'18012', nom:'El Ancer', code_wilaya:18},
        {id:659, code_postal:'18013', nom:'Sidi Abdelaziz', code_wilaya:18},
        {id:660, code_postal:'18014', nom:'Kaous', code_wilaya:18},
        {id:661, code_postal:'18015', nom:'Ghebala', code_wilaya:18},
        {id:662, code_postal:'18016', nom:'Bouraoui Belhadef', code_wilaya:18},
        {id:663, code_postal:'18017', nom:'Djmila', code_wilaya:18},
        {id:664, code_postal:'18018', nom:'Selma Benziada', code_wilaya:18},
        {id:665, code_postal:'18019', nom:'Boussif Ouled Askeur', code_wilaya:18},
        {id:666, code_postal:'18020', nom:'El Kennar Nouchfi', code_wilaya:18},
        {id:667, code_postal:'18021', nom:'Ouled Yahia Khadrouch', code_wilaya:18},
        {id:668, code_postal:'18022', nom:'Boudria Beni Yadjis', code_wilaya:18},
        {id:669, code_postal:'18023', nom:'Kemir Oued Adjoul', code_wilaya:18},
        {id:670, code_postal:'18024', nom:'Texena', code_wilaya:18},
        {id:671, code_postal:'18025', nom:'Djemaa Beni Habibi', code_wilaya:18},
        {id:672, code_postal:'18026', nom:'Bordj Taher', code_wilaya:18},
        {id:673, code_postal:'18027', nom:'Ouled Rabah', code_wilaya:18},
        {id:674, code_postal:'18028', nom:'Ouadjana', code_wilaya:18},],
    [{id:0, nom: "Choisir Commune",},
        {id:675, code_postal:'19001', nom:'Setif', code_wilaya:19},
        {id:676, code_postal:'19002', nom:'Ain El Kebira', code_wilaya:19},
        {id:677, code_postal:'19003', nom:'Beni Aziz', code_wilaya:19},
        {id:678, code_postal:'19004', nom:'Ouled Sidi Ahmed', code_wilaya:19},
        {id:679, code_postal:'19005', nom:'Boutaleb', code_wilaya:19},
        {id:680, code_postal:'19006', nom:'Ain Roua', code_wilaya:19},
        {id:681, code_postal:'19007', nom:'Draa Kebila', code_wilaya:19},
        {id:682, code_postal:'19008', nom:'Bir El Arch', code_wilaya:19},
        {id:683, code_postal:'19009', nom:'Beni Chebana', code_wilaya:19},
        {id:684, code_postal:'19010', nom:'Ouled Tebben', code_wilaya:19},
        {id:685, code_postal:'19011', nom:'Hamma', code_wilaya:19},
        {id:686, code_postal:'19012', nom:'Maaouia', code_wilaya:19},
        {id:687, code_postal:'19013', nom:'Ain Legraj', code_wilaya:19},
        {id:688, code_postal:'19014', nom:'Ain Abessa', code_wilaya:19},
        {id:689, code_postal:'19015', nom:'Dehamcha', code_wilaya:19},
        {id:690, code_postal:'19016', nom:'Babor', code_wilaya:19},
        {id:691, code_postal:'19017', nom:'Guidjel', code_wilaya:19},
        {id:692, code_postal:'19018', nom:'Ain Lahdjar', code_wilaya:19},
        {id:693, code_postal:'19019', nom:'Bousselam', code_wilaya:19},
        {id:694, code_postal:'19020', nom:'El Eulma', code_wilaya:19},
        {id:695, code_postal:'19021', nom:'Djemila', code_wilaya:19},
        {id:696, code_postal:'19022', nom:'Beni Ouartilane', code_wilaya:19},
        {id:697, code_postal:'19023', nom:'Rosfa', code_wilaya:19},
        {id:698, code_postal:'19024', nom:'Ouled Addouane', code_wilaya:19},
        {id:699, code_postal:'19025', nom:'Belaa', code_wilaya:19},
        {id:700, code_postal:'19026', nom:'Ain Arnat', code_wilaya:19},
        {id:701, code_postal:'19027', nom:'Amoucha', code_wilaya:19},
        {id:702, code_postal:'19028', nom:'Ain Oulmane', code_wilaya:19},
        {id:703, code_postal:'19029', nom:'Beidha Bordj', code_wilaya:19},
        {id:704, code_postal:'19030', nom:'Bouandas', code_wilaya:19},
        {id:705, code_postal:'19031', nom:'Bazer Sakhra', code_wilaya:19},
        {id:706, code_postal:'19032', nom:'Hammam Essokhna', code_wilaya:19},
        {id:707, code_postal:'19033', nom:'Mezloug', code_wilaya:19},
        {id:708, code_postal:'19034', nom:'Bir Haddada', code_wilaya:19},
        {id:709, code_postal:'19035', nom:'Serdj El Ghoul', code_wilaya:19},
        {id:710, code_postal:'19036', nom:'Harbil', code_wilaya:19},
        {id:711, code_postal:'19037', nom:'El Ouricia', code_wilaya:19},
        {id:712, code_postal:'19038', nom:'Tizi Nbechar', code_wilaya:19},
        {id:713, code_postal:'19039', nom:'Salah Bey', code_wilaya:19},
        {id:714, code_postal:'19040', nom:'Ain Azal', code_wilaya:19},
        {id:715, code_postal:'19041', nom:'Guenzet', code_wilaya:19},
        {id:716, code_postal:'19042', nom:'Talaifacene', code_wilaya:19},
        {id:717, code_postal:'19043', nom:'Bougaa', code_wilaya:19},
        {id:718, code_postal:'19044', nom:'Beni Fouda', code_wilaya:19},
        {id:719, code_postal:'19045', nom:'Tachouda', code_wilaya:19},
        {id:720, code_postal:'19046', nom:'Beni Mouhli', code_wilaya:19},
        {id:721, code_postal:'19047', nom:'Ouled Sabor', code_wilaya:19},
        {id:722, code_postal:'19048', nom:'Guellal', code_wilaya:19},
        {id:723, code_postal:'19049', nom:'Ain Sebt', code_wilaya:19},
        {id:724, code_postal:'19050', nom:'Hammam Guergour', code_wilaya:19},
        {id:725, code_postal:'19051', nom:'Ait Naoual Mezada', code_wilaya:19},
        {id:726, code_postal:'19052', nom:'Ksar El Abtal', code_wilaya:19},
        {id:727, code_postal:'19053', nom:'Beni Hocine', code_wilaya:19},
        {id:728, code_postal:'19054', nom:'Ait Tizi', code_wilaya:19},
        {id:729, code_postal:'19055', nom:'Maouklane', code_wilaya:19},
        {id:730, code_postal:'19056', nom:'Guelta Zerka', code_wilaya:19},
        {id:731, code_postal:'19057', nom:'Oued El Barad', code_wilaya:19},
        {id:732, code_postal:'19058', nom:'Taya', code_wilaya:19},
        {id:733, code_postal:'19059', nom:'El Ouldja', code_wilaya:19},
        {id:734, code_postal:'19060', nom:'Tella', code_wilaya:19},],
    [{id:0, nom: "Choisir Commune",},
        {id:735, code_postal:'20001', nom:'Saida', code_wilaya:20},
        {id:736, code_postal:'20002', nom:'Doui Thabet', code_wilaya:20},
        {id:737, code_postal:'20003', nom:'Ain El Hadjar', code_wilaya:20},
        {id:738, code_postal:'20004', nom:'Ouled Khaled', code_wilaya:20},
        {id:739, code_postal:'20005', nom:'Moulay Larbi', code_wilaya:20},
        {id:740, code_postal:'20006', nom:'Youb', code_wilaya:20},
        {id:741, code_postal:'20007', nom:'Hounet', code_wilaya:20},
        {id:742, code_postal:'20008', nom:'Sidi Amar', code_wilaya:20},
        {id:743, code_postal:'20009', nom:'Sidi Boubekeur', code_wilaya:20},
        {id:744, code_postal:'20010', nom:'El Hassasna', code_wilaya:20},
        {id:745, code_postal:'20011', nom:'Maamora', code_wilaya:20},
        {id:746, code_postal:'20012', nom:'Sidi Ahmed', code_wilaya:20},
        {id:747, code_postal:'20013', nom:'Ain Sekhouna', code_wilaya:20},
        {id:748, code_postal:'20014', nom:'Ouled Brahim', code_wilaya:20},
        {id:749, code_postal:'20015', nom:'Tircine', code_wilaya:20},
        {id:750, code_postal:'20016', nom:'Ain Soltane', code_wilaya:20},],
    [{id:0, nom: "Choisir Commune",},
          {id:751, code_postal:'21001', nom:'Skikda', code_wilaya:21},
        {id:752, code_postal:'21002', nom:'Ain Zouit', code_wilaya:21},
        {id:753, code_postal:'21003', nom:'El Hadaik', code_wilaya:21},
        {id:754, code_postal:'21004', nom:'Azzaba', code_wilaya:21},
        {id:755, code_postal:'21005', nom:'Djendel Saadi Mohamed', code_wilaya:21},
        {id:756, code_postal:'21006', nom:'Ain Cherchar', code_wilaya:21},
        {id:757, code_postal:'21007', nom:'Bekkouche Lakhdar', code_wilaya:21},
        {id:758, code_postal:'21008', nom:'Benazouz', code_wilaya:21},
        {id:759, code_postal:'21009', nom:'Es Sebt', code_wilaya:21},
        {id:760, code_postal:'21010', nom:'Collo', code_wilaya:21},
        {id:761, code_postal:'21011', nom:'Beni Zid', code_wilaya:21},
        {id:762, code_postal:'21012', nom:'Kerkera', code_wilaya:21},
        {id:763, code_postal:'21013', nom:'Ouled Attia', code_wilaya:21},
        {id:764, code_postal:'21014', nom:'Oued Zehour', code_wilaya:21},
        {id:765, code_postal:'21015', nom:'Zitouna', code_wilaya:21},
        {id:766, code_postal:'21016', nom:'El Harrouch', code_wilaya:21},
        {id:767, code_postal:'21017', nom:'Zerdazas', code_wilaya:21},
        {id:768, code_postal:'21018', nom:'Ouled Hebaba', code_wilaya:21},
        {id:769, code_postal:'21019', nom:'Sidi Mezghiche', code_wilaya:21},
        {id:770, code_postal:'21020', nom:'Emdjez Edchich', code_wilaya:21},
        {id:771, code_postal:'21021', nom:'Beni Oulbane', code_wilaya:21},
        {id:772, code_postal:'21022', nom:'Ain Bouziane', code_wilaya:21},
        {id:773, code_postal:'21023', nom:'Ramdane Djamel', code_wilaya:21},
        {id:774, code_postal:'21024', nom:'Beni Bachir', code_wilaya:21},
        {id:775, code_postal:'21025', nom:'Salah Bouchaour', code_wilaya:21},
        {id:776, code_postal:'21026', nom:'Tamalous', code_wilaya:21},
        {id:777, code_postal:'21027', nom:'Ain Kechra', code_wilaya:21},
        {id:778, code_postal:'21028', nom:'Oum Toub', code_wilaya:21},
        {id:779, code_postal:'21029', nom:'Bein El Ouiden', code_wilaya:21},
        {id:780, code_postal:'21030', nom:'Fil Fila', code_wilaya:21},
        {id:781, code_postal:'21031', nom:'Cheraia', code_wilaya:21},
        {id:782, code_postal:'21032', nom:'Kanoua', code_wilaya:21},
        {id:783, code_postal:'21033', nom:'El Ghedir', code_wilaya:21},
        {id:784, code_postal:'21034', nom:'Bouchtata', code_wilaya:21},
        {id:785, code_postal:'21035', nom:'Ouldja Boulbalout', code_wilaya:21},
        {id:786, code_postal:'21036', nom:'Kheneg Mayoum', code_wilaya:21},
        {id:787, code_postal:'21037', nom:'Hamadi Krouma', code_wilaya:21},
        {id:788, code_postal:'21038', nom:'El Marsa', code_wilaya:21},],
    [{id:0, nom: "Choisir Commune",},
          {id:789, code_postal:'22001', nom:'Sidi Bel Abbes', code_wilaya:22},
        {id:790, code_postal:'22002', nom:'Tessala', code_wilaya:22},
        {id:791, code_postal:'22003', nom:'Sidi Brahim', code_wilaya:22},
        {id:792, code_postal:'22004', nom:'Mostefa Ben Brahim', code_wilaya:22},
        {id:793, code_postal:'22005', nom:'Telagh', code_wilaya:22},
        {id:794, code_postal:'22006', nom:'Mezaourou', code_wilaya:22},
        {id:795, code_postal:'22007', nom:'Boukhanafis', code_wilaya:22},
        {id:796, code_postal:'22008', nom:'Sidi Ali Boussidi', code_wilaya:22},
        {id:797, code_postal:'22009', nom:'Badredine El Mokrani', code_wilaya:22},
        {id:798, code_postal:'22010', nom:'Marhoum', code_wilaya:22},
        {id:799, code_postal:'22011', nom:'Tafissour', code_wilaya:22},
        {id:800, code_postal:'22012', nom:'Amarnas', code_wilaya:22},
        {id:801, code_postal:'22013', nom:'Tilmouni', code_wilaya:22},
        {id:802, code_postal:'22014', nom:'Sidi Lahcene', code_wilaya:22},
        {id:803, code_postal:'22015', nom:'Ain Thrid', code_wilaya:22},
        {id:804, code_postal:'22016', nom:'Makedra', code_wilaya:22},
        {id:805, code_postal:'22017', nom:'Tenira', code_wilaya:22},
        {id:806, code_postal:'22018', nom:'Moulay Slissen', code_wilaya:22},
        {id:807, code_postal:'22019', nom:'El Hacaiba', code_wilaya:22},
        {id:808, code_postal:'22020', nom:'Hassi Zehana', code_wilaya:22},
        {id:809, code_postal:'22021', nom:'Tabia', code_wilaya:22},
        {id:810, code_postal:'22022', nom:'Merine', code_wilaya:22},
        {id:811, code_postal:'22023', nom:'Ras El Ma', code_wilaya:22},
        {id:812, code_postal:'22024', nom:'Ain Tindamine', code_wilaya:22},
        {id:813, code_postal:'22025', nom:'Ain Kada', code_wilaya:22},
        {id:814, code_postal:'22026', nom:'Mcid', code_wilaya:22},
        {id:815, code_postal:'22027', nom:'Sidi Khaled', code_wilaya:22},
        {id:816, code_postal:'22028', nom:'Ain El Berd', code_wilaya:22},
        {id:817, code_postal:'22029', nom:'Sfissef', code_wilaya:22},
        {id:818, code_postal:'22030', nom:'Ain Adden', code_wilaya:22},
        {id:819, code_postal:'22031', nom:'Oued Taourira', code_wilaya:22},
        {id:820, code_postal:'22032', nom:'Dhaya', code_wilaya:22},
        {id:821, code_postal:'22033', nom:'Zerouala', code_wilaya:22},
        {id:822, code_postal:'22034', nom:'Lamtar', code_wilaya:22},
        {id:823, code_postal:'22035', nom:'Sidi Chaib', code_wilaya:22},
        {id:824, code_postal:'22036', nom:'Sidi Dahou Dezairs', code_wilaya:22},
        {id:825, code_postal:'22037', nom:'Oued Sbaa', code_wilaya:22},
        {id:826, code_postal:'22038', nom:'Boudjebaa El Bordj', code_wilaya:22},
        {id:827, code_postal:'22039', nom:'Sehala Thaoura', code_wilaya:22},
        {id:828, code_postal:'22040', nom:'Sidi Yacoub', code_wilaya:22},
        {id:829, code_postal:'22041', nom:'Sidi Hamadouche', code_wilaya:22},
        {id:830, code_postal:'22042', nom:'Belarbi', code_wilaya:22},
        {id:831, code_postal:'22043', nom:'Oued Sefioun', code_wilaya:22},
        {id:832, code_postal:'22044', nom:'Teghalimet', code_wilaya:22},
        {id:833, code_postal:'22045', nom:'Ben Badis', code_wilaya:22},
        {id:834, code_postal:'22046', nom:'Sidi Ali Benyoub', code_wilaya:22},
        {id:835, code_postal:'22047', nom:'Chetouane Belaila', code_wilaya:22},
        {id:836, code_postal:'22048', nom:'Bir El Hammam', code_wilaya:22},
        {id:837, code_postal:'22049', nom:'Taoudmout', code_wilaya:22},
        {id:838, code_postal:'22050', nom:'Redjem Demouche', code_wilaya:22},
        {id:839, code_postal:'22051', nom:'Benachiba Chelia', code_wilaya:22},
        {id:840, code_postal:'22052', nom:'Hassi Dahou', code_wilaya:22},],
    [{id:0, nom: "Choisir Commune",},
        {id:841, code_postal:'23001', nom:'Annaba', code_wilaya:23},
        {id:842, code_postal:'23002', nom:'Berrahel', code_wilaya:23},
        {id:843, code_postal:'23003', nom:'El Hadjar', code_wilaya:23},
        {id:844, code_postal:'23004', nom:'Eulma', code_wilaya:23},
        {id:845, code_postal:'23005', nom:'El Bouni', code_wilaya:23},
        {id:846, code_postal:'23006', nom:'Oued El Aneb', code_wilaya:23},
        {id:847, code_postal:'23007', nom:'Cheurfa', code_wilaya:23},
        {id:848, code_postal:'23008', nom:'Seraidi', code_wilaya:23},
        {id:849, code_postal:'23009', nom:'Ain Berda', code_wilaya:23},
        {id:850, code_postal:'23010', nom:'Chetaibi', code_wilaya:23},
        {id:851, code_postal:'23011', nom:'Sidi Amer', code_wilaya:23},
        {id:852, code_postal:'23012', nom:'Treat', code_wilaya:23},],
    [{id:0, nom: "Choisir Commune",},
         {id:853, code_postal:'24001', nom:'Guelma', code_wilaya:24},
        {id:854, code_postal:'24002', nom:'Nechmaya', code_wilaya:24},
        {id:855, code_postal:'24003', nom:'Bouati Mahmoud', code_wilaya:24},
        {id:856, code_postal:'24004', nom:'Oued Zenati', code_wilaya:24},
        {id:857, code_postal:'24005', nom:'Tamlouka', code_wilaya:24},
        {id:858, code_postal:'24006', nom:'Oued Fragha', code_wilaya:24},
        {id:859, code_postal:'24007', nom:'Ain Sandel', code_wilaya:24},
        {id:860, code_postal:'24008', nom:'Ras El Agba', code_wilaya:24},
        {id:861, code_postal:'24009', nom:'Dahouara', code_wilaya:24},
        {id:862, code_postal:'24010', nom:'Belkhir', code_wilaya:24},
        {id:863, code_postal:'24011', nom:'Ben Djarah', code_wilaya:24},
        {id:864, code_postal:'24012', nom:'Bou Hamdane', code_wilaya:24},
        {id:865, code_postal:'24013', nom:'Ain Makhlouf', code_wilaya:24},
        {id:866, code_postal:'24014', nom:'Ain Ben Beida', code_wilaya:24},
        {id:867, code_postal:'24015', nom:'Khezara', code_wilaya:24},
        {id:868, code_postal:'24016', nom:'Beni Mezline', code_wilaya:24},
        {id:869, code_postal:'24017', nom:'Bou Hachana', code_wilaya:24},
        {id:870, code_postal:'24018', nom:'Guelaat Bou Sbaa', code_wilaya:24},
        {id:871, code_postal:'24019', nom:'Hammam Maskhoutine', code_wilaya:24},
        {id:872, code_postal:'24020', nom:'El Fedjoudj', code_wilaya:24},
        {id:873, code_postal:'24021', nom:'Bordj Sabat', code_wilaya:24},
        {id:874, code_postal:'24022', nom:'Hamman Nbail', code_wilaya:24},
        {id:875, code_postal:'24023', nom:'Ain Larbi', code_wilaya:24},
        {id:876, code_postal:'24024', nom:'Medjez Amar', code_wilaya:24},
        {id:877, code_postal:'24025', nom:'Bouchegouf', code_wilaya:24},
        {id:878, code_postal:'24026', nom:'Heliopolis', code_wilaya:24},
        {id:879, code_postal:'24027', nom:'Ain Hessania', code_wilaya:24},
        {id:880, code_postal:'24028', nom:'Roknia', code_wilaya:24},
        {id:881, code_postal:'24029', nom:'Salaoua Announa', code_wilaya:24},
        {id:882, code_postal:'24030', nom:'Medjez Sfa', code_wilaya:24},
        {id:883, code_postal:'24031', nom:'Boumahra Ahmed', code_wilaya:24},
        {id:884, code_postal:'24032', nom:'Ain Reggada', code_wilaya:24},
        {id:885, code_postal:'24033', nom:'Oued Cheham', code_wilaya:24},
        {id:886, code_postal:'24034', nom:'Djeballah Khemissi', code_wilaya:24},],
    [{id:0, nom: "Choisir Commune",},
        {id:887, code_postal:'25001', nom:'Constantine', code_wilaya:25},
        {id:888, code_postal:'25002', nom:'Hamma Bouziane', code_wilaya:25},
        {id:889, code_postal:'25003', nom:'El Haria', code_wilaya:25},
        {id:890, code_postal:'25004', nom:'Zighoud Youcef', code_wilaya:25},
        {id:891, code_postal:'25005', nom:'Didouche Mourad', code_wilaya:25},
        {id:892, code_postal:'25006', nom:'El Khroub', code_wilaya:25},
        {id:893, code_postal:'25007', nom:'Ain Abid', code_wilaya:25},
        {id:894, code_postal:'25008', nom:'Beni Hamiden', code_wilaya:25},
        {id:895, code_postal:'25009', nom:'Ouled Rahmoune', code_wilaya:25},
        {id:896, code_postal:'25010', nom:'Ain Smara', code_wilaya:25},
        {id:897, code_postal:'25011', nom:'Mesaoud Boudjeriou', code_wilaya:25},
        {id:898, code_postal:'25012', nom:'Ibn Ziad', code_wilaya:25},],
    [{id:0, nom: "Choisir Commune",},
        {id:899, code_postal:'26001', nom:'Medea', code_wilaya:26},
        {id:900, code_postal:'26002', nom:'Ouzera', code_wilaya:26},
        {id:901, code_postal:'26003', nom:'Ouled Maaref', code_wilaya:26},
        {id:902, code_postal:'26004', nom:'Ain Boucif', code_wilaya:26},
        {id:903, code_postal:'26005', nom:'Aissaouia', code_wilaya:26},
        {id:904, code_postal:'26006', nom:'Ouled Deide', code_wilaya:26},
        {id:905, code_postal:'26007', nom:'El Omaria', code_wilaya:26},
        {id:906, code_postal:'26008', nom:'Derrag', code_wilaya:26},
        {id:907, code_postal:'26009', nom:'El Guelbelkebir', code_wilaya:26},
        {id:908, code_postal:'26010', nom:'Bouaiche', code_wilaya:26},
        {id:909, code_postal:'26011', nom:'Mezerena', code_wilaya:26},
        {id:910, code_postal:'26012', nom:'Ouled Brahim', code_wilaya:26},
        {id:911, code_postal:'26013', nom:'Damiat', code_wilaya:26},
        {id:912, code_postal:'26014', nom:'Sidi Ziane', code_wilaya:26},
        {id:913, code_postal:'26015', nom:'Tamesguida', code_wilaya:26},
        {id:914, code_postal:'26016', nom:'El Hamdania', code_wilaya:26},
        {id:915, code_postal:'26017', nom:'Kef Lakhdar', code_wilaya:26},
        {id:916, code_postal:'26018', nom:'Chelalet El Adhaoura', code_wilaya:26},
        {id:917, code_postal:'26019', nom:'Bouskene', code_wilaya:26},
        {id:918, code_postal:'26020', nom:'Rebaia', code_wilaya:26},
        {id:919, code_postal:'26021', nom:'Bouchrahil', code_wilaya:26},
        {id:920, code_postal:'26022', nom:'Ouled Hellal', code_wilaya:26},
        {id:921, code_postal:'26023', nom:'Tafraout', code_wilaya:26},
        {id:922, code_postal:'26024', nom:'Baata', code_wilaya:26},
        {id:923, code_postal:'26025', nom:'Boghar', code_wilaya:26},
        {id:924, code_postal:'26026', nom:'Sidi Naamane', code_wilaya:26},
        {id:925, code_postal:'26027', nom:'Ouled Bouachra', code_wilaya:26},
        {id:926, code_postal:'26028', nom:'Sidi Zahar', code_wilaya:26},
        {id:927, code_postal:'26029', nom:'Oued Harbil', code_wilaya:26},
        {id:928, code_postal:'26030', nom:'Benchicao', code_wilaya:26},
        {id:929, code_postal:'26031', nom:'Sidi Damed', code_wilaya:26},
        {id:930, code_postal:'26032', nom:'Aziz', code_wilaya:26},
        {id:931, code_postal:'26033', nom:'Souagui', code_wilaya:26},
        {id:932, code_postal:'26034', nom:'Zoubiria', code_wilaya:26},
        {id:933, code_postal:'26035', nom:'Ksar El Boukhari', code_wilaya:26},
        {id:934, code_postal:'26036', nom:'El Azizia', code_wilaya:26},
        {id:935, code_postal:'26037', nom:'Djouab', code_wilaya:26},
        {id:936, code_postal:'26038', nom:'Chahbounia', code_wilaya:26},
        {id:937, code_postal:'26039', nom:'Meghraoua', code_wilaya:26},
        {id:938, code_postal:'26040', nom:'Cheniguel', code_wilaya:26},
        {id:939, code_postal:'26041', nom:'Ain Ouksir', code_wilaya:26},
        {id:940, code_postal:'26042', nom:'Oum El Djalil', code_wilaya:26},
        {id:941, code_postal:'26043', nom:'Ouamri', code_wilaya:26},
        {id:942, code_postal:'26044', nom:'Si Mahdjoub', code_wilaya:26},
        {id:943, code_postal:'26045', nom:'Tlatet Eddoair', code_wilaya:26},
        {id:944, code_postal:'26046', nom:'Beni Slimane', code_wilaya:26},
        {id:945, code_postal:'26047', nom:'Berrouaghia', code_wilaya:26},
        {id:946, code_postal:'26048', nom:'Seghouane', code_wilaya:26},
        {id:947, code_postal:'26049', nom:'Meftaha', code_wilaya:26},
        {id:948, code_postal:'26050', nom:'Mihoub', code_wilaya:26},
        {id:949, code_postal:'26051', nom:'Boughezoul', code_wilaya:26},
        {id:950, code_postal:'26052', nom:'Tablat', code_wilaya:26},
        {id:951, code_postal:'26053', nom:'Deux Bassins', code_wilaya:26},
        {id:952, code_postal:'26054', nom:'Draa Essamar', code_wilaya:26},
        {id:953, code_postal:'26055', nom:'Sidi Errabia', code_wilaya:26},
        {id:954, code_postal:'26056', nom:'Bir Ben Laabed', code_wilaya:26},
        {id:955, code_postal:'26057', nom:'El Ouinet', code_wilaya:26},
        {id:956, code_postal:'26058', nom:'Ouled Antar', code_wilaya:26},
        {id:957, code_postal:'26059', nom:'Bouaichoune', code_wilaya:26},
        {id:958, code_postal:'26060', nom:'Hannacha', code_wilaya:26},
        {id:959, code_postal:'26061', nom:'Sedraia', code_wilaya:26},
        {id:960, code_postal:'26062', nom:'Medjebar', code_wilaya:26},
        {id:961, code_postal:'26063', nom:'Khams Djouamaa', code_wilaya:26},
        {id:962, code_postal:'26064', nom:'Saneg', code_wilaya:26},],
    [{id:0, nom: "Choisir Commune",},
        {id:963, code_postal:'27001', nom:'Mostaganem', code_wilaya:27},
        {id:964, code_postal:'27002', nom:'Sayada', code_wilaya:27},
        {id:965, code_postal:'27003', nom:'Fornaka', code_wilaya:27},
        {id:966, code_postal:'27004', nom:'Stidia', code_wilaya:27},
        {id:967, code_postal:'27005', nom:'Ain Nouissy', code_wilaya:27},
        {id:968, code_postal:'27006', nom:'Hassi Maameche', code_wilaya:27},
        {id:969, code_postal:'27007', nom:'Ain Tadles', code_wilaya:27},
        {id:970, code_postal:'27008', nom:'Sour', code_wilaya:27},
        {id:971, code_postal:'27009', nom:'Oued El Kheir', code_wilaya:27},
        {id:972, code_postal:'27010', nom:'Sidi Bellater', code_wilaya:27},
        {id:973, code_postal:'27011', nom:'Kheiredine ', code_wilaya:27},
        {id:974, code_postal:'27012', nom:'Sidi Ali', code_wilaya:27},
        {id:975, code_postal:'27013', nom:'Abdelmalek Ramdane', code_wilaya:27},
        {id:976, code_postal:'27014', nom:'Hadjadj', code_wilaya:27},
        {id:977, code_postal:'27015', nom:'Nekmaria', code_wilaya:27},
        {id:978, code_postal:'27016', nom:'Sidi Lakhdar', code_wilaya:27},
        {id:979, code_postal:'27017', nom:'Achaacha', code_wilaya:27},
        {id:980, code_postal:'27018', nom:'Khadra', code_wilaya:27},
        {id:981, code_postal:'27019', nom:'Bouguirat', code_wilaya:27},
        {id:982, code_postal:'27020', nom:'Sirat', code_wilaya:27},
        {id:983, code_postal:'27021', nom:'Ain Sidi Cherif', code_wilaya:27},
        {id:984, code_postal:'27022', nom:'Mesra', code_wilaya:27},
        {id:985, code_postal:'27023', nom:'Mansourah', code_wilaya:27},
        {id:986, code_postal:'27024', nom:'Souaflia', code_wilaya:27},
        {id:987, code_postal:'27025', nom:'Ouled Boughalem', code_wilaya:27},
        {id:988, code_postal:'27026', nom:'Ouled Maallah', code_wilaya:27},
        {id:989, code_postal:'27027', nom:'Mezghrane', code_wilaya:27},
        {id:990, code_postal:'27028', nom:'Ain Boudinar', code_wilaya:27},
        {id:991, code_postal:'27029', nom:'Tazgait', code_wilaya:27},
        {id:992, code_postal:'27030', nom:'Safsaf', code_wilaya:27},
        {id:993, code_postal:'27031', nom:'Touahria', code_wilaya:27},
        {id:994, code_postal:'27032', nom:'El Hassiane', code_wilaya:27},],
    [{id:0, nom: "Choisir Commune",},
        {id:995, code_postal:'28001', nom:'Msila', code_wilaya:28},
        {id:996, code_postal:'28002', nom:'Maadid', code_wilaya:28},
        {id:997, code_postal:'28003', nom:'Hammam Dhalaa', code_wilaya:28},
        {id:998, code_postal:'28004', nom:'Ouled Derradj', code_wilaya:28},
        {id:999, code_postal:'28005', nom:'Tarmount', code_wilaya:28},
        {id:1000, code_postal:'28006', nom:'Mtarfa', code_wilaya:28},
        {id:1001, code_postal:'28007', nom:'Khoubana', code_wilaya:28},
        {id:1002, code_postal:'28008', nom:'Mcif', code_wilaya:28},
        {id:1003, code_postal:'28009', nom:'Chellal', code_wilaya:28},
        {id:1004, code_postal:'28010', nom:'Ouled Madhi', code_wilaya:28},
        {id:1005, code_postal:'28011', nom:'Magra', code_wilaya:28},
        {id:1006, code_postal:'28012', nom:'Berhoum', code_wilaya:28},
        {id:1007, code_postal:'28013', nom:'Ain Khadra', code_wilaya:28},
        {id:1008, code_postal:'28014', nom:'Ouled Addi Guebala', code_wilaya:28},
        {id:1009, code_postal:'28015', nom:'Belaiba', code_wilaya:28},
        {id:1010, code_postal:'28016', nom:'Sidi Aissa', code_wilaya:28},
        {id:1011, code_postal:'28017', nom:'Ain El Hadjel', code_wilaya:28},
        {id:1012, code_postal:'28018', nom:'Sidi Hadjeres', code_wilaya:28},
        {id:1013, code_postal:'28019', nom:'Ouanougha', code_wilaya:28},
        {id:1014, code_postal:'28020', nom:'Bou Saada', code_wilaya:28},
        {id:1015, code_postal:'28021', nom:'Ouled Sidi Brahim', code_wilaya:28},
        {id:1016, code_postal:'28022', nom:'Sidi Ameur', code_wilaya:28},
        {id:1017, code_postal:'28023', nom:'Tamsa', code_wilaya:28},
        {id:1018, code_postal:'28024', nom:'Ben Srour', code_wilaya:28},
        {id:1019, code_postal:'28025', nom:'Ouled Slimane', code_wilaya:28},
        {id:1020, code_postal:'28026', nom:'El Houamed', code_wilaya:28},
        {id:1021, code_postal:'28027', nom:'El Hamel', code_wilaya:28},
        {id:1022, code_postal:'28028', nom:'Ouled Mansour', code_wilaya:28},
        {id:1023, code_postal:'28029', nom:'Maarif', code_wilaya:28},
        {id:1024, code_postal:'28030', nom:'Dehahna', code_wilaya:28},
        {id:1025, code_postal:'28031', nom:'Bouti Sayah', code_wilaya:28},
        {id:1026, code_postal:'28032', nom:'Khettouti Sed Djir', code_wilaya:28},
        {id:1027, code_postal:'28033', nom:'Zarzour', code_wilaya:28},
        {id:1028, code_postal:'28034', nom:'Oued Chair', code_wilaya:28},
        {id:1029, code_postal:'28035', nom:'Benzouh', code_wilaya:28},
        {id:1030, code_postal:'28036', nom:'Bir Foda', code_wilaya:28},
        {id:1031, code_postal:'28037', nom:'Ain Fares', code_wilaya:28},
        {id:1032, code_postal:'28038', nom:'Sidi Mhamed', code_wilaya:28},
        {id:1033, code_postal:'28039', nom:'Ouled Atia', code_wilaya:28},
        {id:1034, code_postal:'28040', nom:'Souamaa', code_wilaya:28},
        {id:1035, code_postal:'28041', nom:'Ain El Melh', code_wilaya:28},
        {id:1036, code_postal:'28042', nom:'Medjedel', code_wilaya:28},
        {id:1037, code_postal:'28043', nom:'Slim', code_wilaya:28},
        {id:1038, code_postal:'28044', nom:'Ain Errich', code_wilaya:28},
        {id:1039, code_postal:'28045', nom:'Beni Ilmane', code_wilaya:28},
        {id:1040, code_postal:'28046', nom:'Oultene', code_wilaya:28},
        {id:1041, code_postal:'28047', nom:'Djebel Messaad', code_wilaya:28},],
    [{id:0, nom: "Choisir Commune",},
         {id:1042, code_postal:'29001', nom:'Mascara', code_wilaya:29},
        {id:1043, code_postal:'29002', nom:'Bou Hanifia', code_wilaya:29},
        {id:1044, code_postal:'29003', nom:'Tizi', code_wilaya:29},
        {id:1045, code_postal:'29004', nom:'Hacine', code_wilaya:29},
        {id:1046, code_postal:'29005', nom:'Maoussa', code_wilaya:29},
        {id:1047, code_postal:'29006', nom:'Teghennif', code_wilaya:29},
        {id:1048, code_postal:'29007', nom:'El Hachem', code_wilaya:29},
        {id:1049, code_postal:'29008', nom:'Sidi Kada', code_wilaya:29},
        {id:1050, code_postal:'29009', nom:'Zelmata', code_wilaya:29},
        {id:1051, code_postal:'29010', nom:'Oued El Abtal', code_wilaya:29},
        {id:1052, code_postal:'29011', nom:'Ain Ferah', code_wilaya:29},
        {id:1053, code_postal:'29012', nom:'Ghriss', code_wilaya:29},
        {id:1054, code_postal:'29013', nom:'Froha', code_wilaya:29},
        {id:1055, code_postal:'29014', nom:'Matemore', code_wilaya:29},
        {id:1056, code_postal:'29015', nom:'Makdha', code_wilaya:29},
        {id:1057, code_postal:'29016', nom:'Sidi Boussaid', code_wilaya:29},
        {id:1058, code_postal:'29017', nom:'El Bordj', code_wilaya:29},
        {id:1059, code_postal:'29018', nom:'Ain Fekan', code_wilaya:29},
        {id:1060, code_postal:'29019', nom:'Benian', code_wilaya:29},
        {id:1061, code_postal:'29020', nom:'Khalouia', code_wilaya:29},
        {id:1062, code_postal:'29021', nom:'El Menaouer', code_wilaya:29},
        {id:1063, code_postal:'29022', nom:'Oued Taria', code_wilaya:29},
        {id:1064, code_postal:'29023', nom:'Aouf', code_wilaya:29},
        {id:1065, code_postal:'29024', nom:'Ain Fares', code_wilaya:29},
        {id:1066, code_postal:'29025', nom:'Ain Frass', code_wilaya:29},
        {id:1067, code_postal:'29026', nom:'Sig', code_wilaya:29},
        {id:1068, code_postal:'29027', nom:'Oggaz', code_wilaya:29},
        {id:1069, code_postal:'29028', nom:'Alaimia', code_wilaya:29},
        {id:1070, code_postal:'29029', nom:'El Gaada', code_wilaya:29},
        {id:1071, code_postal:'29030', nom:'Zahana', code_wilaya:29},
        {id:1072, code_postal:'29031', nom:'Mohammadia', code_wilaya:29},
        {id:1073, code_postal:'29032', nom:'Sidi Abdelmoumene', code_wilaya:29},
        {id:1074, code_postal:'29033', nom:'Ferraguig', code_wilaya:29},
        {id:1075, code_postal:'29034', nom:'El Ghomri', code_wilaya:29},
        {id:1076, code_postal:'29035', nom:'Sedjerara', code_wilaya:29},
        {id:1077, code_postal:'29036', nom:'Moctadouz', code_wilaya:29},
        {id:1078, code_postal:'29037', nom:'Bou Henni', code_wilaya:29},
        {id:1079, code_postal:'29038', nom:'Guettena', code_wilaya:29},
        {id:1080, code_postal:'29039', nom:'El Mamounia', code_wilaya:29},
        {id:1081, code_postal:'29040', nom:'El Keurt', code_wilaya:29},
        {id:1082, code_postal:'29041', nom:'Gharrous', code_wilaya:29},
        {id:1083, code_postal:'29042', nom:'Gherdjoum', code_wilaya:29},
        {id:1084, code_postal:'29043', nom:'Chorfa', code_wilaya:29},
        {id:1085, code_postal:'29044', nom:'Ras Ain Amirouche', code_wilaya:29},
        {id:1086, code_postal:'29045', nom:'Nesmot', code_wilaya:29},
        {id:1087, code_postal:'29046', nom:'Sidi Abdeldjebar', code_wilaya:29},
        {id:1088, code_postal:'29047', nom:'Sehailia', code_wilaya:29},],
    [{id:0, nom: "Choisir Commune",},
        {id:1089, code_postal:'30001', nom:'Ouargla', code_wilaya:30},
        {id:1090, code_postal:'30002', nom:'Ain Beida', code_wilaya:30},
        {id:1091, code_postal:'30003', nom:'Ngoussa', code_wilaya:30},
        {id:1092, code_postal:'30004', nom:'Hassi Messaoud', code_wilaya:30},
        {id:1093, code_postal:'30005', nom:'Rouissat', code_wilaya:30},
        {id:1094, code_postal:'30006', nom:'Balidat Ameur', code_wilaya:30},
        {id:1095, code_postal:'30007', nom:'Tebesbest', code_wilaya:30},
        {id:1096, code_postal:'30008', nom:'Nezla', code_wilaya:30},
        {id:1097, code_postal:'30009', nom:'Zaouia El Abidia', code_wilaya:30},
        {id:1098, code_postal:'30010', nom:'Sidi Slimane', code_wilaya:30},
        {id:1099, code_postal:'30011', nom:'Sidi Khouiled', code_wilaya:30},
        {id:1100, code_postal:'30012', nom:'Hassi Ben Abdellah', code_wilaya:30},
        {id:1101, code_postal:'30013', nom:'Touggourt', code_wilaya:30},
        {id:1102, code_postal:'30014', nom:'El Hadjira', code_wilaya:30},
        {id:1103, code_postal:'30015', nom:'Taibet', code_wilaya:30},
        {id:1104, code_postal:'30016', nom:'Tamacine', code_wilaya:30},
        {id:1105, code_postal:'30017', nom:'Benaceur', code_wilaya:30},
        {id:1106, code_postal:'30018', nom:'Mnaguer', code_wilaya:30},
        {id:1107, code_postal:'30019', nom:'Megarine', code_wilaya:30},
        {id:1108, code_postal:'30020', nom:'El Allia', code_wilaya:30},
        {id:1109, code_postal:'30021', nom:'El Borma', code_wilaya:30},],
    [{id:0, nom: "Choisir Commune",},
        {id:1110, code_postal:'31001', nom:'Oran', code_wilaya:31},
        {id:1111, code_postal:'31002', nom:'Gdyel', code_wilaya:31},
        {id:1112, code_postal:'31003', nom:'Bir El Djir', code_wilaya:31},
        {id:1113, code_postal:'31004', nom:'Hassi Bounif', code_wilaya:31},
        {id:1114, code_postal:'31005', nom:'Es Senia', code_wilaya:31},
        {id:1115, code_postal:'31006', nom:'Arzew', code_wilaya:31},
        {id:1116, code_postal:'31007', nom:'Bethioua', code_wilaya:31},
        {id:1117, code_postal:'31008', nom:'Marsat El Hadjadj', code_wilaya:31},
        {id:1118, code_postal:'31009', nom:'Ain Turk', code_wilaya:31},
        {id:1119, code_postal:'31010', nom:'El Ancar', code_wilaya:31},
        {id:1120, code_postal:'31011', nom:'Oued Tlelat', code_wilaya:31},
        {id:1121, code_postal:'31012', nom:'Tafraoui', code_wilaya:31},
        {id:1122, code_postal:'31013', nom:'Sidi Chami', code_wilaya:31},
        {id:1123, code_postal:'31014', nom:'Boufatis', code_wilaya:31},
        {id:1124, code_postal:'31015', nom:'Mers El Kebir', code_wilaya:31},
        {id:1125, code_postal:'31016', nom:'Bousfer', code_wilaya:31},
        {id:1126, code_postal:'31017', nom:'El Karma', code_wilaya:31},
        {id:1127, code_postal:'31018', nom:'El Braya', code_wilaya:31},
        {id:1128, code_postal:'31019', nom:'Hassi Ben Okba', code_wilaya:31},
        {id:1129, code_postal:'31020', nom:'Ben Freha', code_wilaya:31},
        {id:1130, code_postal:'31021', nom:'Hassi Mefsoukh', code_wilaya:31},
        {id:1131, code_postal:'31022', nom:'Sidi Ben Yabka', code_wilaya:31},
        {id:1132, code_postal:'31023', nom:'Messerghin', code_wilaya:31},
        {id:1133, code_postal:'31024', nom:'Boutlelis', code_wilaya:31},
        {id:1134, code_postal:'31025', nom:'Ain Kerma', code_wilaya:31},
        {id:1135, code_postal:'31026', nom:'Ain Biya', code_wilaya:31},],
    [{id:0, nom: "Choisir Commune",},
         {id:1136, code_postal:'32001', nom:'El Bayadh', code_wilaya:32},
        {id:1137, code_postal:'32002', nom:'Rogassa', code_wilaya:32},
        {id:1138, code_postal:'32003', nom:'Stitten', code_wilaya:32},
        {id:1139, code_postal:'32004', nom:'Brezina', code_wilaya:32},
        {id:1140, code_postal:'32005', nom:'Ghassoul', code_wilaya:32},
        {id:1141, code_postal:'32006', nom:'Boualem', code_wilaya:32},
        {id:1142, code_postal:'32007', nom:'El Abiodh Sidi Cheikh', code_wilaya:32},
        {id:1143, code_postal:'32008', nom:'Ain El Orak', code_wilaya:32},
        {id:1144, code_postal:'32009', nom:'Arbaouat', code_wilaya:32},
        {id:1145, code_postal:'32010', nom:'Bougtoub', code_wilaya:32},
        {id:1146, code_postal:'32011', nom:'El Kheither', code_wilaya:32},
        {id:1147, code_postal:'32012', nom:'Kef El Ahmar', code_wilaya:32},
        {id:1148, code_postal:'32013', nom:'Boussemghoun', code_wilaya:32},
        {id:1149, code_postal:'32014', nom:'Chellala', code_wilaya:32},
        {id:1150, code_postal:'32015', nom:'Krakda', code_wilaya:32},
        {id:1151, code_postal:'32016', nom:'El Bnoud', code_wilaya:32},
        {id:1152, code_postal:'32017', nom:'Cheguig', code_wilaya:32},
        {id:1153, code_postal:'32018', nom:'Sidi Ameur', code_wilaya:32},
        {id:1154, code_postal:'32019', nom:'El Mehara', code_wilaya:32},
        {id:1155, code_postal:'32020', nom:'Tousmouline', code_wilaya:32},
        {id:1156, code_postal:'32021', nom:'Sidi Slimane', code_wilaya:32},
        {id:1157, code_postal:'32022', nom:'Sidi Tifour', code_wilaya:32},],
    [{id:0, nom: "Choisir Commune",},
         {id:1158, code_postal:'33001', nom:'Illizi', code_wilaya:33},
        {id:1159, code_postal:'33002', nom:'Djanet', code_wilaya:33},
        {id:1160, code_postal:'33003', nom:'Debdeb', code_wilaya:33},
        {id:1161, code_postal:'33004', nom:'Bordj Omar Driss', code_wilaya:33},
        {id:1162, code_postal:'33005', nom:'Bordj El Haouasse', code_wilaya:33},
        {id:1163, code_postal:'33006', nom:'In Amenas', code_wilaya:33},],
    [{id:0, nom: "Choisir Commune",},
        {id:1164, code_postal:'34001', nom:'Bordj Bou Arreridj', code_wilaya:34},
        {id:1165, code_postal:'34002', nom:'Ras El Oued', code_wilaya:34},
        {id:1166, code_postal:'34003', nom:'Bordj Zemoura', code_wilaya:34},
        {id:1167, code_postal:'34004', nom:'Mansoura', code_wilaya:34},
        {id:1168, code_postal:'34005', nom:'El Mhir', code_wilaya:34},
        {id:1169, code_postal:'34006', nom:'Ben Daoud', code_wilaya:34},
        {id:1170, code_postal:'34007', nom:'El Achir', code_wilaya:34},
        {id:1171, code_postal:'34008', nom:'Ain Taghrout', code_wilaya:34},
        {id:1172, code_postal:'34009', nom:'Bordj Ghdir', code_wilaya:34},
        {id:1173, code_postal:'34010', nom:'Sidi Embarek', code_wilaya:34},
        {id:1174, code_postal:'34011', nom:'El Hamadia', code_wilaya:34},
        {id:1175, code_postal:'34012', nom:'Belimour', code_wilaya:34},
        {id:1176, code_postal:'34013', nom:'Medjana', code_wilaya:34},
        {id:1177, code_postal:'34014', nom:'Teniet En Nasr', code_wilaya:34},
        {id:1178, code_postal:'34015', nom:'Djaafra', code_wilaya:34},
        {id:1179, code_postal:'34016', nom:'El Main', code_wilaya:34},
        {id:1180, code_postal:'34017', nom:'Ouled Brahem', code_wilaya:34},
        {id:1181, code_postal:'34018', nom:'Ouled Dahmane', code_wilaya:34},
        {id:1182, code_postal:'34019', nom:'Hasnaoua', code_wilaya:34},
        {id:1183, code_postal:'34020', nom:'Khelil', code_wilaya:34},
        {id:1184, code_postal:'34021', nom:'Taglait', code_wilaya:34},
        {id:1185, code_postal:'34022', nom:'Ksour', code_wilaya:34},
        {id:1186, code_postal:'34023', nom:'Ouled Sidi Brahim', code_wilaya:34},
        {id:1187, code_postal:'34024', nom:'Tafreg', code_wilaya:34},
        {id:1188, code_postal:'34025', nom:'Colla', code_wilaya:34},
        {id:1189, code_postal:'34026', nom:'Tixter', code_wilaya:34},
        {id:1190, code_postal:'34027', nom:'El Ach', code_wilaya:34},
        {id:1191, code_postal:'34028', nom:'El Anseur', code_wilaya:34},
        {id:1192, code_postal:'34029', nom:'Tesmart', code_wilaya:34},
        {id:1193, code_postal:'34030', nom:'Ain Tesra', code_wilaya:34},
        {id:1194, code_postal:'34031', nom:'Bir Kasdali', code_wilaya:34},
        {id:1195, code_postal:'34032', nom:'Ghilassa', code_wilaya:34},
        {id:1196, code_postal:'34033', nom:'Rabta', code_wilaya:34},
        {id:1197, code_postal:'34034', nom:'Haraza', code_wilaya:34},],
    [{id:0, nom: "Choisir Commune",},
         {id:1198, code_postal:'35001', nom:'Boumerdes', code_wilaya:35},
        {id:1199, code_postal:'35002', nom:'Boudouaou', code_wilaya:35},
        {id:1200, code_postal:'35004', nom:'Afir', code_wilaya:35},
        {id:1201, code_postal:'35005', nom:'Bordj Menaiel', code_wilaya:35},
        {id:1202, code_postal:'35006', nom:'Baghlia', code_wilaya:35},
        {id:1203, code_postal:'35007', nom:'Sidi Daoud', code_wilaya:35},
        {id:1204, code_postal:'35008', nom:'Naciria', code_wilaya:35},
        {id:1205, code_postal:'35009', nom:'Djinet', code_wilaya:35},
        {id:1206, code_postal:'35010', nom:'Isser', code_wilaya:35},
        {id:1207, code_postal:'35011', nom:'Zemmouri', code_wilaya:35},
        {id:1208, code_postal:'35012', nom:'Si Mustapha', code_wilaya:35},
        {id:1209, code_postal:'35013', nom:'Tidjelabine', code_wilaya:35},
        {id:1210, code_postal:'35014', nom:'Chabet El Ameur', code_wilaya:35},
        {id:1211, code_postal:'35015', nom:'Thenia', code_wilaya:35},
        {id:1212, code_postal:'35018', nom:'Timezrit', code_wilaya:35},
        {id:1213, code_postal:'35019', nom:'Corso', code_wilaya:35},
        {id:1214, code_postal:'35020', nom:'Ouled Moussa', code_wilaya:35},
        {id:1215, code_postal:'35021', nom:'Larbatache', code_wilaya:35},
        {id:1216, code_postal:'35022', nom:'Bouzegza Keddara', code_wilaya:35},
        {id:1217, code_postal:'35025', nom:'Taourga', code_wilaya:35},
        {id:1218, code_postal:'35026', nom:'Ouled Aissa', code_wilaya:35},
        {id:1219, code_postal:'35027', nom:'Ben Choud', code_wilaya:35},
        {id:1220, code_postal:'35028', nom:'Dellys', code_wilaya:35},
        {id:1221, code_postal:'35029', nom:'Ammal', code_wilaya:35},
        {id:1222, code_postal:'35030', nom:'Beni Amrane', code_wilaya:35},
        {id:1223, code_postal:'35031', nom:'Souk El Had', code_wilaya:35},
        {id:1224, code_postal:'35032', nom:'Boudouaou El Bahri', code_wilaya:35},
        {id:1225, code_postal:'35033', nom:'Ouled Hedadj', code_wilaya:35},
        {id:1226, code_postal:'35035', nom:'Laghata', code_wilaya:35},
        {id:1227, code_postal:'35036', nom:'Hammedi', code_wilaya:35},
        {id:1228, code_postal:'35037', nom:'Khemis El Khechna', code_wilaya:35},
        {id:1229, code_postal:'35038', nom:'El Kharrouba', code_wilaya:35},   ],
    [{id:0, nom: "Choisir Commune",},
         {id:1230, code_postal:'36001', nom:'El Tarf', code_wilaya:36},
        {id:1231, code_postal:'36002', nom:'Bouhadjar', code_wilaya:36},
        {id:1232, code_postal:'36003', nom:'Ben Mhidi', code_wilaya:36},
        {id:1233, code_postal:'36004', nom:'Bougous', code_wilaya:36},
        {id:1234, code_postal:'36005', nom:'El Kala', code_wilaya:36},
        {id:1235, code_postal:'36006', nom:'Ain El Assel', code_wilaya:36},
        {id:1236, code_postal:'36007', nom:'El Aioun', code_wilaya:36},
        {id:1237, code_postal:'36008', nom:'Bouteldja', code_wilaya:36},
        {id:1238, code_postal:'36009', nom:'Souarekh', code_wilaya:36},
        {id:1239, code_postal:'36010', nom:'Berrihane', code_wilaya:36},
        {id:1240, code_postal:'36011', nom:'Lac Des Oiseaux', code_wilaya:36},
        {id:1241, code_postal:'36012', nom:'Chefia', code_wilaya:36},
        {id:1242, code_postal:'36013', nom:'Drean', code_wilaya:36},
        {id:1243, code_postal:'36014', nom:'Chihani', code_wilaya:36},
        {id:1244, code_postal:'36015', nom:'Chebaita Mokhtar', code_wilaya:36},
        {id:1245, code_postal:'36016', nom:'Besbes', code_wilaya:36},
        {id:1246, code_postal:'36017', nom:'Asfour', code_wilaya:36},
        {id:1247, code_postal:'36018', nom:'Echatt', code_wilaya:36},
        {id:1248, code_postal:'36019', nom:'Zerizer', code_wilaya:36},
        {id:1249, code_postal:'36020', nom:'Zitouna', code_wilaya:36},
        {id:1250, code_postal:'36021', nom:'Ain Kerma', code_wilaya:36},
        {id:1251, code_postal:'36022', nom:'Oued Zitoun', code_wilaya:36},
        {id:1252, code_postal:'36023', nom:'Hammam Beni Salah', code_wilaya:36},
        {id:1253, code_postal:'36024', nom:'Raml Souk', code_wilaya:36},],
    [{id:0, nom: "Choisir Commune",},
        {id:1254, code_postal:'37001', nom:'Tindouf', code_wilaya:37},
        {id:1255, code_postal:'37002', nom:'Oum El Assel', code_wilaya:37},],
    [{id:0, nom: "Choisir Commune",},
        {id:1256, code_postal:'38001', nom:'Tissemsilt', code_wilaya:38},
        {id:1257, code_postal:'38002', nom:'Bordj Bou Naama', code_wilaya:38},
        {id:1258, code_postal:'38003', nom:'Theniet El Had', code_wilaya:38},
        {id:1259, code_postal:'38004', nom:'Lazharia', code_wilaya:38},
        {id:1260, code_postal:'38005', nom:'Beni Chaib', code_wilaya:38},
        {id:1261, code_postal:'38006', nom:'Lardjem', code_wilaya:38},
        {id:1262, code_postal:'38007', nom:'Melaab', code_wilaya:38},
        {id:1263, code_postal:'38008', nom:'Sidi Lantri', code_wilaya:38},
        {id:1264, code_postal:'38009', nom:'Bordj El Emir Abdelkader', code_wilaya:38},
        {id:1265, code_postal:'38010', nom:'Layoune', code_wilaya:38},
        {id:1266, code_postal:'38011', nom:'Khemisti', code_wilaya:38},
        {id:1267, code_postal:'38012', nom:'Ouled Bessem', code_wilaya:38},
        {id:1268, code_postal:'38013', nom:'Ammari', code_wilaya:38},
        {id:1269, code_postal:'38014', nom:'Youssoufia', code_wilaya:38},
        {id:1270, code_postal:'38015', nom:'Sidi Boutouchent', code_wilaya:38},
        {id:1271, code_postal:'38016', nom:'Larbaa', code_wilaya:38},
        {id:1272, code_postal:'38017', nom:'Maasem', code_wilaya:38},
        {id:1273, code_postal:'38018', nom:'Sidi Abed', code_wilaya:38},
        {id:1274, code_postal:'38019', nom:'Tamalaht', code_wilaya:38},
        {id:1275, code_postal:'38020', nom:'Sidi Slimane', code_wilaya:38},
        {id:1276, code_postal:'38021', nom:'Boucaid', code_wilaya:38},
        {id:1277, code_postal:'38022', nom:'Beni Lahcene', code_wilaya:38},],
    [{id:0, nom: "Choisir Commune",},
        {id:1278, code_postal:'39001', nom:'El Oued', code_wilaya:39},
        {id:1279, code_postal:'39002', nom:'Robbah', code_wilaya:39},
        {id:1280, code_postal:'39003', nom:'Oued El Alenda', code_wilaya:39},
        {id:1281, code_postal:'39004', nom:'Bayadha', code_wilaya:39},
        {id:1282, code_postal:'39005', nom:'Nakhla', code_wilaya:39},
        {id:1283, code_postal:'39006', nom:'Guemar', code_wilaya:39},
        {id:1284, code_postal:'39007', nom:'Kouinine', code_wilaya:39},
        {id:1285, code_postal:'39008', nom:'Reguiba', code_wilaya:39},
        {id:1286, code_postal:'39009', nom:'Hamraia', code_wilaya:39},
        {id:1287, code_postal:'39010', nom:'Taghzout', code_wilaya:39},
        {id:1288, code_postal:'39011', nom:'Debila', code_wilaya:39},
        {id:1289, code_postal:'39012', nom:'Hassani Abdelkrim', code_wilaya:39},
        {id:1290, code_postal:'39013', nom:'Hassi Khelifa', code_wilaya:39},
        {id:1291, code_postal:'39014', nom:'Taleb Larbi', code_wilaya:39},
        {id:1292, code_postal:'39015', nom:'Douar El Ma', code_wilaya:39},
        {id:1293, code_postal:'39016', nom:'Sidi Aoun', code_wilaya:39},
        {id:1294, code_postal:'39017', nom:'Trifaoui', code_wilaya:39},
        {id:1295, code_postal:'39018', nom:'Magrane', code_wilaya:39},
        {id:1296, code_postal:'39019', nom:'Beni Guecha', code_wilaya:39},
        {id:1297, code_postal:'39020', nom:'Ourmas', code_wilaya:39},
        {id:1298, code_postal:'39021', nom:'Still', code_wilaya:39},
        {id:1299, code_postal:'39022', nom:'Mrara', code_wilaya:39},
        {id:1300, code_postal:'39023', nom:'Sidi Khellil', code_wilaya:39},
        {id:1301, code_postal:'39024', nom:'Tendla', code_wilaya:39},
        {id:1302, code_postal:'39025', nom:'El Ogla', code_wilaya:39},
        {id:1303, code_postal:'39026', nom:'Mih Ouansa', code_wilaya:39},
        {id:1304, code_postal:'39027', nom:'El Mghair', code_wilaya:39},
        {id:1305, code_postal:'39028', nom:'Djamaa', code_wilaya:39},
        {id:1306, code_postal:'39029', nom:'Oum Touyour', code_wilaya:39},
        {id:1307, code_postal:'39030', nom:'Sidi Amrane', code_wilaya:39},],
    [{id:0, nom: "Choisir Commune",},
        {id:1308, code_postal:'40001', nom:'Khenchela', code_wilaya:40},
        {id:1309, code_postal:'40002', nom:'Mtoussa', code_wilaya:40},
        {id:1310, code_postal:'40003', nom:'Kais', code_wilaya:40},
        {id:1311, code_postal:'40004', nom:'Baghai', code_wilaya:40},
        {id:1312, code_postal:'40005', nom:'El Hamma', code_wilaya:40},
        {id:1313, code_postal:'40006', nom:'Ain Touila', code_wilaya:40},
        {id:1314, code_postal:'40007', nom:'Taouzianat', code_wilaya:40},
        {id:1315, code_postal:'40008', nom:'Bouhmama', code_wilaya:40},
        {id:1316, code_postal:'40009', nom:'El Oueldja', code_wilaya:40},
        {id:1317, code_postal:'40010', nom:'Remila', code_wilaya:40},
        {id:1318, code_postal:'40011', nom:'Cherchar', code_wilaya:40},
        {id:1319, code_postal:'40012', nom:'Djellal', code_wilaya:40},
        {id:1320, code_postal:'40013', nom:'Babar', code_wilaya:40},
        {id:1321, code_postal:'40014', nom:'Tamza', code_wilaya:40},
        {id:1322, code_postal:'40015', nom:'Ensigha', code_wilaya:40},
        {id:1323, code_postal:'40016', nom:'Ouled Rechache', code_wilaya:40},
        {id:1324, code_postal:'40017', nom:'El Mahmal', code_wilaya:40},
        {id:1325, code_postal:'40018', nom:'Msara', code_wilaya:40},
        {id:1326, code_postal:'40019', nom:'Yabous', code_wilaya:40},
        {id:1327, code_postal:'40020', nom:'Khirane', code_wilaya:40},
        {id:1328, code_postal:'40021', nom:'Chelia', code_wilaya:40},],
    [{id:0, nom: "Choisir Commune",},
        {id:1329, code_postal:'41001', nom:'Souk Ahras', code_wilaya:41},
        {id:1330, code_postal:'41002', nom:'Sedrata', code_wilaya:41},
        {id:1331, code_postal:'41003', nom:'Hanancha', code_wilaya:41},
        {id:1332, code_postal:'41004', nom:'Mechroha', code_wilaya:41},
        {id:1333, code_postal:'41005', nom:'Ouled Driss', code_wilaya:41},
        {id:1334, code_postal:'41006', nom:'Tiffech', code_wilaya:41},
        {id:1335, code_postal:'41007', nom:'Zaarouria', code_wilaya:41},
        {id:1336, code_postal:'41008', nom:'Taoura', code_wilaya:41},
        {id:1337, code_postal:'41009', nom:'Drea', code_wilaya:41},
        {id:1338, code_postal:'41010', nom:'Haddada', code_wilaya:41},
        {id:1339, code_postal:'41011', nom:'Khedara', code_wilaya:41},
        {id:1340, code_postal:'41012', nom:'Merahna', code_wilaya:41},
        {id:1341, code_postal:'41013', nom:'Ouled Moumen', code_wilaya:41},
        {id:1342, code_postal:'41014', nom:'Bir Bouhouche', code_wilaya:41},
        {id:1343, code_postal:'41015', nom:'Mdaourouche', code_wilaya:41},
        {id:1344, code_postal:'41016', nom:'Oum El Adhaim', code_wilaya:41},
        {id:1345, code_postal:'41017', nom:'Ain Zana', code_wilaya:41},
        {id:1346, code_postal:'41018', nom:'Ain Soltane', code_wilaya:41},
        {id:1347, code_postal:'41019', nom:'Quillen', code_wilaya:41},
        {id:1348, code_postal:'41020', nom:'Sidi Fredj', code_wilaya:41},
        {id:1349, code_postal:'41021', nom:'Safel El Ouiden', code_wilaya:41},
        {id:1350, code_postal:'41022', nom:'Ragouba', code_wilaya:41},
        {id:1351, code_postal:'41023', nom:'Khemissa', code_wilaya:41},
        {id:1352, code_postal:'41024', nom:'Oued Keberit', code_wilaya:41},
        {id:1353, code_postal:'41025', nom:'Terraguelt', code_wilaya:41},
        {id:1354, code_postal:'41026', nom:'Zouabi', code_wilaya:41},],
    [{id:0, nom: "Choisir Commune",},
        {id:1355, code_postal:'42001', nom:'Tipaza', code_wilaya:42},
        {id:1356, code_postal:'42002', nom:'Menaceur', code_wilaya:42},
        {id:1357, code_postal:'42003', nom:'Larhat', code_wilaya:42},
        {id:1358, code_postal:'42004', nom:'Douaouda', code_wilaya:42},
        {id:1359, code_postal:'42005', nom:'Bourkika', code_wilaya:42},
        {id:1360, code_postal:'42006', nom:'Khemisti', code_wilaya:42},
        {id:1361, code_postal:'42010', nom:'Aghabal', code_wilaya:42},
        {id:1362, code_postal:'42012', nom:'Hadjout', code_wilaya:42},
        {id:1363, code_postal:'42013', nom:'Sidi Amar', code_wilaya:42},
        {id:1364, code_postal:'42014', nom:'Gouraya', code_wilaya:42},
        {id:1365, code_postal:'42015', nom:'Nodor', code_wilaya:42},
        {id:1366, code_postal:'42016', nom:'Chaiba', code_wilaya:42},
        {id:1367, code_postal:'42017', nom:'Ain Tagourait', code_wilaya:42},
        {id:1368, code_postal:'42022', nom:'Cherchel', code_wilaya:42},
        {id:1369, code_postal:'42023', nom:'Damous', code_wilaya:42},
        {id:1370, code_postal:'42024', nom:'Meurad', code_wilaya:42},
        {id:1371, code_postal:'42025', nom:'Fouka', code_wilaya:42},
        {id:1372, code_postal:'42026', nom:'Bou Ismail', code_wilaya:42},
        {id:1373, code_postal:'42027', nom:'Ahmer El Ain', code_wilaya:42},
        {id:1374, code_postal:'42030', nom:'Bou Haroun', code_wilaya:42},
        {id:1375, code_postal:'42032', nom:'Sidi Ghiles', code_wilaya:42},
        {id:1376, code_postal:'42033', nom:'Messelmoun', code_wilaya:42},
        {id:1377, code_postal:'42034', nom:'Sidi Rached', code_wilaya:42},
        {id:1378, code_postal:'42035', nom:'Kolea', code_wilaya:42},
        {id:1379, code_postal:'42036', nom:'Attatba', code_wilaya:42},
        {id:1380, code_postal:'42040', nom:'Sidi Semiane', code_wilaya:42},
        {id:1381, code_postal:'42041', nom:'Beni Milleuk', code_wilaya:42},
        {id:1382, code_postal:'42042', nom:'Hadjerat Ennous', code_wilaya:42},],
    [{id:0, nom: "Choisir Commune",},
        {id:1383, code_postal:'43001', nom:'Mila', code_wilaya:43},
        {id:1384, code_postal:'43002', nom:'Ferdjioua', code_wilaya:43},
        {id:1385, code_postal:'43003', nom:'Chelghoum Laid', code_wilaya:43},
        {id:1386, code_postal:'43004', nom:'Oued Athmenia', code_wilaya:43},
        {id:1387, code_postal:'43005', nom:'Ain Mellouk', code_wilaya:43},
        {id:1388, code_postal:'43006', nom:'Telerghma', code_wilaya:43},
        {id:1389, code_postal:'43007', nom:'Oued Seguen', code_wilaya:43},
        {id:1390, code_postal:'43008', nom:'Tadjenanet', code_wilaya:43},
        {id:1391, code_postal:'43009', nom:'Benyahia Abderrahmane', code_wilaya:43},
        {id:1392, code_postal:'43010', nom:'Oued Endja', code_wilaya:43},
        {id:1393, code_postal:'43011', nom:'Ahmed Rachedi', code_wilaya:43},
        {id:1394, code_postal:'43012', nom:'Ouled Khalouf', code_wilaya:43},
        {id:1395, code_postal:'43013', nom:'Tiberguent', code_wilaya:43},
        {id:1396, code_postal:'43014', nom:'Bouhatem', code_wilaya:43},
        {id:1397, code_postal:'43015', nom:'Rouached', code_wilaya:43},
        {id:1398, code_postal:'43016', nom:'Tessala Lamatai', code_wilaya:43},
        {id:1399, code_postal:'43017', nom:'Grarem Gouga', code_wilaya:43},
        {id:1400, code_postal:'43018', nom:'Sidi Merouane', code_wilaya:43},
        {id:1401, code_postal:'43019', nom:'Tassadane Haddada', code_wilaya:43},
        {id:1402, code_postal:'43020', nom:'Derradji Bousselah', code_wilaya:43},
        {id:1403, code_postal:'43021', nom:'Minar Zarza', code_wilaya:43},
        {id:1404, code_postal:'43022', nom:'Amira Arras', code_wilaya:43},
        {id:1405, code_postal:'43023', nom:'Terrai Bainen', code_wilaya:43},
        {id:1406, code_postal:'43024', nom:'Hamala', code_wilaya:43},
        {id:1407, code_postal:'43025', nom:'Ain Tine', code_wilaya:43},
        {id:1408, code_postal:'43026', nom:'El Mechira', code_wilaya:43},
        {id:1409, code_postal:'43027', nom:'Sidi Khelifa', code_wilaya:43},
        {id:1410, code_postal:'43028', nom:'Zeghaia', code_wilaya:43},
        {id:1411, code_postal:'43029', nom:'Elayadi Barbes', code_wilaya:43},
        {id:1412, code_postal:'43030', nom:'Ain Beida Harriche', code_wilaya:43},
        {id:1413, code_postal:'43031', nom:'Yahia Beniguecha', code_wilaya:43},
        {id:1414, code_postal:'43032', nom:'Chigara', code_wilaya:43},],
    [{id:0, nom: "Choisir Commune",},
        {id:1415, code_postal:'44001', nom:'Ain Defla', code_wilaya:44},
        {id:1416, code_postal:'44002', nom:'Miliana', code_wilaya:44},
        {id:1417, code_postal:'44003', nom:'Boumedfaa', code_wilaya:44},
        {id:1418, code_postal:'44004', nom:'Khemis Miliana', code_wilaya:44},
        {id:1419, code_postal:'44005', nom:'Hammam Righa', code_wilaya:44},
        {id:1420, code_postal:'44006', nom:'Arib', code_wilaya:44},
        {id:1421, code_postal:'44007', nom:'Djelida', code_wilaya:44},
        {id:1422, code_postal:'44008', nom:'El Amra', code_wilaya:44},
        {id:1423, code_postal:'44009', nom:'Bourached', code_wilaya:44},
        {id:1424, code_postal:'44010', nom:'El Attaf', code_wilaya:44},
        {id:1425, code_postal:'44011', nom:'El Abadia', code_wilaya:44},
        {id:1426, code_postal:'44012', nom:'Djendel', code_wilaya:44},
        {id:1427, code_postal:'44013', nom:'Oued Chorfa', code_wilaya:44},
        {id:1428, code_postal:'44014', nom:'Ain Lechiakh', code_wilaya:44},
        {id:1429, code_postal:'44015', nom:'Oued Djemaa', code_wilaya:44},
        {id:1430, code_postal:'44016', nom:'Rouina', code_wilaya:44},
        {id:1431, code_postal:'44017', nom:'Zeddine', code_wilaya:44},
        {id:1432, code_postal:'44018', nom:'El Hassania', code_wilaya:44},
        {id:1433, code_postal:'44019', nom:'Bir Ouled Khelifa', code_wilaya:44},
        {id:1434, code_postal:'44020', nom:'Ain Soltane', code_wilaya:44},
        {id:1435, code_postal:'44021', nom:'Tarik Ibn Ziad', code_wilaya:44},
        {id:1436, code_postal:'44022', nom:'Bordj Emir Khaled', code_wilaya:44},
        {id:1437, code_postal:'44023', nom:'Ain Torki', code_wilaya:44},
        {id:1438, code_postal:'44024', nom:'Sidi Lakhdar', code_wilaya:44},
        {id:1439, code_postal:'44025', nom:'Ben Allal', code_wilaya:44},
        {id:1440, code_postal:'44026', nom:'Ain Benian', code_wilaya:44},
        {id:1441, code_postal:'44027', nom:'Hoceinia', code_wilaya:44},
        {id:1442, code_postal:'44028', nom:'Barbouche', code_wilaya:44},
        {id:1443, code_postal:'44029', nom:'Djemaa Ouled Chikh', code_wilaya:44},
        {id:1444, code_postal:'44030', nom:'Mekhatria', code_wilaya:44},
        {id:1445, code_postal:'44031', nom:'Bathia', code_wilaya:44},
        {id:1446, code_postal:'44032', nom:'Tachta Zegagha', code_wilaya:44},
        {id:1447, code_postal:'44033', nom:'Ain Bouyahia', code_wilaya:44},
        {id:1448, code_postal:'44034', nom:'El Maine', code_wilaya:44},
        {id:1449, code_postal:'44035', nom:'Tiberkanine', code_wilaya:44},
        {id:1450, code_postal:'44036', nom:'Belaas', code_wilaya:44},],
    [{id:0, nom: "Choisir Commune",},
        {id:1451, code_postal:'45001', nom:'Naama', code_wilaya:45},
        {id:1452, code_postal:'45002', nom:'Mechria', code_wilaya:45},
        {id:1453, code_postal:'45003', nom:'Ain Sefra', code_wilaya:45},
        {id:1454, code_postal:'45004', nom:'Tiout', code_wilaya:45},
        {id:1455, code_postal:'45005', nom:'Sfissifa', code_wilaya:45},
        {id:1456, code_postal:'45006', nom:'Moghrar', code_wilaya:45},
        {id:1457, code_postal:'45007', nom:'Assela', code_wilaya:45},
        {id:1458, code_postal:'45008', nom:'Djeniane Bourzeg', code_wilaya:45},
        {id:1459, code_postal:'45009', nom:'Ain Ben Khelil', code_wilaya:45},
        {id:1460, code_postal:'45010', nom:'Makman Ben Amer', code_wilaya:45},
        {id:1461, code_postal:'45011', nom:'Kasdir', code_wilaya:45},
        {id:1462, code_postal:'45012', nom:'El Biod', code_wilaya:45},],
    [{id:0, nom: "Choisir Commune",},
        {id:1463, code_postal:'46001', nom:'Ain Temouchent', code_wilaya:46},
        {id:1464, code_postal:'46002', nom:'Chaabet El Ham', code_wilaya:46},
        {id:1465, code_postal:'46003', nom:'Ain Kihal', code_wilaya:46},
        {id:1466, code_postal:'46004', nom:'Hammam Bouhadjar', code_wilaya:46},
        {id:1467, code_postal:'46005', nom:'Bou Zedjar', code_wilaya:46},
        {id:1468, code_postal:'46006', nom:'Oued Berkeche', code_wilaya:46},
        {id:1469, code_postal:'46007', nom:'Aghlal', code_wilaya:46},
        {id:1470, code_postal:'46008', nom:'Terga', code_wilaya:46},
        {id:1471, code_postal:'46009', nom:'Ain El Arbaa', code_wilaya:46},
        {id:1472, code_postal:'46010', nom:'Tamzoura', code_wilaya:46},
        {id:1473, code_postal:'46011', nom:'Chentouf', code_wilaya:46},
        {id:1474, code_postal:'46012', nom:'Sidi Ben Adda', code_wilaya:46},
        {id:1475, code_postal:'46013', nom:'Aoubellil', code_wilaya:46},
        {id:1476, code_postal:'46014', nom:'El Malah', code_wilaya:46},
        {id:1477, code_postal:'46015', nom:'Sidi Boumediene', code_wilaya:46},
        {id:1478, code_postal:'46016', nom:'Oued Sabah', code_wilaya:46},
        {id:1479, code_postal:'46017', nom:'Ouled Boudjemaa', code_wilaya:46},
        {id:1480, code_postal:'46018', nom:'Ain Tolba', code_wilaya:46},
        {id:1481, code_postal:'46019', nom:'El Amria', code_wilaya:46},
        {id:1482, code_postal:'46020', nom:'Hassi El Ghella', code_wilaya:46},
        {id:1483, code_postal:'46021', nom:'Hassasna', code_wilaya:46},
        {id:1484, code_postal:'46022', nom:'Ouled Kihal', code_wilaya:46},
        {id:1485, code_postal:'46023', nom:'Beni Saf', code_wilaya:46},
        {id:1486, code_postal:'46024', nom:'Sidi Safi', code_wilaya:46},
        {id:1487, code_postal:'46025', nom:'Oulhaca El Gheraba', code_wilaya:46},
        {id:1488, code_postal:'46026', nom:'Tadmaya', code_wilaya:46},
        {id:1489, code_postal:'46027', nom:'El Emir Abdelkader', code_wilaya:46},
        {id:1490, code_postal:'46028', nom:'El Messaid', code_wilaya:46},],
    [{id:0, nom: "Choisir Commune",},
        {id:1491, code_postal:'47001', nom:'Ghardaia', code_wilaya:47},
        {id:1492, code_postal:'47002', nom:'El Meniaa', code_wilaya:47},
        {id:1493, code_postal:'47003', nom:'Dhayet Bendhahoua', code_wilaya:47},
        {id:1494, code_postal:'47004', nom:'Berriane', code_wilaya:47},
        {id:1495, code_postal:'47005', nom:'Metlili', code_wilaya:47},
        {id:1496, code_postal:'47006', nom:'El Guerrara', code_wilaya:47},
        {id:1497, code_postal:'47007', nom:'El Atteuf', code_wilaya:47},
        {id:1498, code_postal:'47008', nom:'Zelfana', code_wilaya:47},
        {id:1499, code_postal:'47009', nom:'Sebseb', code_wilaya:47},
        {id:1500, code_postal:'47010', nom:'Bounoura', code_wilaya:47},
        {id:1501, code_postal:'47011', nom:'Hassi Fehal', code_wilaya:47},
        {id:1502, code_postal:'47012', nom:'Hassi Gara', code_wilaya:47},
        {id:1503, code_postal:'47013', nom:'Mansoura', code_wilaya:47},],
    [{id:0, nom: "Choisir Commune",},
        {id:1504, code_postal:'48001', nom:'Relizane', code_wilaya:48},
        {id:1505, code_postal:'48002', nom:'Oued Rhiou', code_wilaya:48},
        {id:1506, code_postal:'48003', nom:'Belaassel Bouzegza', code_wilaya:48},
        {id:1507, code_postal:'48004', nom:'Sidi Saada', code_wilaya:48},
        {id:1508, code_postal:'48005', nom:'Ouled Aiche', code_wilaya:48},
        {id:1509, code_postal:'48006', nom:'Sidi Lazreg', code_wilaya:48},
        {id:1510, code_postal:'48007', nom:'El Hamadna', code_wilaya:48},
        {id:1511, code_postal:'48008', nom:'Sidi Mhamed Ben Ali', code_wilaya:48},
        {id:1512, code_postal:'48009', nom:'Mediouna', code_wilaya:48},
        {id:1513, code_postal:'48010', nom:'Sidi Khettab', code_wilaya:48},
        {id:1514, code_postal:'48011', nom:'Ammi Moussa', code_wilaya:48},
        {id:1515, code_postal:'48012', nom:'Zemmoura', code_wilaya:48},
        {id:1516, code_postal:'48013', nom:'Beni Dergoun', code_wilaya:48},
        {id:1517, code_postal:'48014', nom:'Djidiouia', code_wilaya:48},
        {id:1518, code_postal:'48015', nom:'El Guettar', code_wilaya:48},
        {id:1519, code_postal:'48016', nom:'Hamri', code_wilaya:48},
        {id:1520, code_postal:'48017', nom:'El Matmar', code_wilaya:48},
        {id:1521, code_postal:'48018', nom:'Sidi Mhamed Ben Aouda', code_wilaya:48},
        {id:1522, code_postal:'48019', nom:'Ain Tarek', code_wilaya:48},
        {id:1523, code_postal:'48020', nom:'Oued Essalem', code_wilaya:48},
        {id:1524, code_postal:'48021', nom:'Ouarizane', code_wilaya:48},
        {id:1525, code_postal:'48022', nom:'Mazouna', code_wilaya:48},
        {id:1526, code_postal:'48023', nom:'Kalaa', code_wilaya:48},
        {id:1527, code_postal:'48024', nom:'Ain Rahma', code_wilaya:48},
        {id:1528, code_postal:'48025', nom:'Yellel', code_wilaya:48},
        {id:1529, code_postal:'48026', nom:'Oued El Djemaa', code_wilaya:48},
        {id:1530, code_postal:'48027', nom:'Ramka', code_wilaya:48},
        {id:1531, code_postal:'48028', nom:'Mendes', code_wilaya:48},
        {id:1532, code_postal:'48029', nom:'Lahlef', code_wilaya:48},
        {id:1533, code_postal:'48030', nom:'Beni Zentis', code_wilaya:48},
        {id:1534, code_postal:'48031', nom:'Souk El Haad', code_wilaya:48},
        {id:1535, code_postal:'48032', nom:'Dar Ben Abdellah', code_wilaya:48},
        {id:1536, code_postal:'48033', nom:'El Hassi', code_wilaya:48},
        {id:1537, code_postal:'48034', nom:'Had Echkalla', code_wilaya:48},
        {id:1538, code_postal:'48035', nom:'Bendaoud', code_wilaya:48},
        {id:1539, code_postal:'48036', nom:'El Ouldja', code_wilaya:48},
        {id:1540, code_postal:'48037', nom:'Merdja Sidi Abed', code_wilaya:48},
        {id:1541, code_postal:'48038', nom:'Ouled Sidi Mihoub', code_wilaya:48},],
    [{id:0, nom: "Choisir Commune",},
        {id:1542,nom: "Tinerkouk",code_wilaya:49,},
        {id:1543,nom: "Timimoun",code_wilaya:49,},
        {id:1544,nom: "Ouled Said",code_wilaya:49,},
        {id:1545,nom: "Metarfa",code_wilaya:49,},
        {id:1546,nom: "Talmine",code_wilaya:49,},
        {id:1547,nom: "Ouled Aissa",code_wilaya:49,},
        {id:1548,nom: "Charouine",code_wilaya:49,},
        {id:1549,nom: "Aougrout",code_wilaya:49,},
        {id:1550,nom: "Deldoul",code_wilaya:49,},
        {id:1551,nom: "Ksar Kaddour",code_wilaya:49,},],
    [{id:0, nom: "Choisir Commune",},
        {id:1552,nom: "Timiaouine",code_wilaya:50,},
        {id:1553,nom: "Bordj Badji Mokhtar",code_wilaya:50,},],
    [{id:0, nom: "Choisir Commune",},
        {id:1554,nom: "Ras El Miad",code_wilaya:51,},
        {id:1555,nom: "Besbes",code_wilaya:51,},
        {id:1556,nom: "Sidi Khaled",code_wilaya:51,},
        {id:1557,nom: "Doucen",code_wilaya:51,},
        {id:1558,nom: "Chaiba",code_wilaya:51,},
        {id:1559,nom: "Ouled Djellal",code_wilaya:51,},],
    [{id:0, nom: "Choisir Commune",},
        {id:1560,nom: "Beni-Abbes",code_wilaya:52,},
        {id:1561,nom: "Tamtert",code_wilaya:52,},
        {id:1562,nom: "Igli",code_wilaya:52,},
        {id:1563,nom: "El Ouata",code_wilaya:52,},
        {id:1564,nom: "Ouled-Khodeir",code_wilaya:52,},
        {id:1565,nom: "Kerzaz",code_wilaya:52,},
        {id:1566,nom: "Timoudi",code_wilaya:52,},
        {id:1567,nom: "Ksabi",code_wilaya:52,},
        {id:1568,nom: "Beni-Ikhlef",code_wilaya:52,},],
    [{id:0, nom: "Choisir Commune",},
        {id:1569,nom: "Inghar",code_wilaya:53,},
        {id:1570,nom: "Ain Salah",code_wilaya:53,},
        {id:1571,nom: "Foggaret Ezzoua",code_wilaya:53,},],
    [{id:0, nom: "Choisir Commune",},
        {id:1572,nom: "Tin Zouatine",code_wilaya:54,},
        {id:1573,nom: "Ain Guezzam",code_wilaya:54,},],
    [{id:0, nom: "Choisir Commune",},
        {id:1574,nom: "Temacine",code_wilaya:55,},
        {id:1575,nom: "Sidi Slimane",code_wilaya:55,},
        {id:1576,nom: "Megarine",code_wilaya:55,},
        {id:1577,nom: "Nezla",code_wilaya:55,},
        {id:1578,nom: "Blidet Amor",code_wilaya:55,},
        {id:1579,nom: "Tebesbest",code_wilaya:55,},
        {id:1580,nom: "Touggourt",code_wilaya:55,},
        {id:1581,nom: "Taibet",code_wilaya:55,},
        {id:1582,nom: "El Alia",code_wilaya:55,},
        {id:1583,nom: "El-Hadjira",code_wilaya:55,},
        {id:1584,nom: "Benaceur",code_wilaya:55,},
        {id:1585,nom: "M'naguer",code_wilaya:55,},
        {id:1586,nom: "Zaouia El Abidia",code_wilaya:55,},],
    [{id:0, nom: "Choisir Commune",},
        {id:1587,nom: "Djanet",code_wilaya:56,},
        {id:1588,nom: "Bordj El Haouass",code_wilaya:56,},],
    [{id:0, nom: "Choisir Commune",},
        {id:1589,nom: "Oum Touyour",code_wilaya:57,},
        {id:1590,nom: "Sidi Amrane",code_wilaya:57,},
        {id:1591,nom: "M'rara",code_wilaya:57,},
        {id:1592,nom: "Djamaa",code_wilaya:57,},
        {id:1593,nom: "Tenedla",code_wilaya:57,},
        {id:1594,nom: "El-M'ghaier",code_wilaya:57,},
        {id:1595,nom: "Still",code_wilaya:57,},
        {id:1596,nom: "Sidi Khelil",code_wilaya:57,},],
    [{id:0, nom: "Choisir Commune",},
        {id:1597,nom: "El Meniaa",code_wilaya:58,},
        {id:1598,nom: "Hassi Gara",code_wilaya:58,},
        {id:1599,nom: "Hassi Fehal",code_wilaya:58,}],
]